// dataFetchTree
// export function* postPreferences(
// postPoster
import { call, delay, put, select, takeLatest, all, fork, spawn, cancel, cancelled } from 'redux-saga/effects';
import { cloneDeep, sortBy } from 'lodash';
import {
  FETCH_TREE,
  dualPedigreeLaunchOnDev,
  dualPedigreeMode,
  FETCH_PROFILES,
  FLUSHALLCALLBACKFORFETCHPROFILES,
  FETCH_PRUNES,
  FETCH_IMMEDIATE_FAMILY,
  FETCH_LEGEND_DESCRIPTIONS,
  FETCH_FLIPDATA,
  FETCH_FLOATERS,
  REMOVE_FLOATER,
  UNSET_FLIPDATA,
  UNSET_NODEOBJ_PROP,
  UNSET_NODEOBJ_PIC,
  UNSET_NODEOBJ_GEDCOM,
  SET_NODEOBJ_PIC,
  // STORE_CUSTOM_RECENTER_IN_DUALPEDIGREE,
  UNDESIGNATE_DROPTARGET,
  STOP_INFLIGHT_SAGAS,
  POST_INVITE,
  POST_PREFERENCES,
  POST_POSTER,
  GETUNION_ID_FANCHART,
  UPLOADPHOTO,
  POSTREDUX_PREFERENCES,
  POST_PREFERENCESCHARTTYPE,
  POST_CHOSENUNIONID,
  FETCH_PREFERENCES,
  ADD_FLOATER,
  CANCEL_SPAWNED_FETCHPROFILES,
  POST_ADD_EXISTING,
  POST_RESOLVE,
  RELEASEQUEUEFETCHEDPROFILESDATA,
  RELEASEQUEUEOFFETCHEDNODEOBJPICS,
  NOTIFYPROFILEADD,
  UPDATEMATCHCOUNTS,
  CHECKQUEUEFETCHEDNODEOBJPIC,
  host,
  imageBasePath,
  isDevelopment,
  isSeinfeld,
  timeDelayForInviteIsSent,
  debugWiderCatchForFetchProfiles,
  debugFetchPrunes,
  fetchPrunesChunkLength,
  timeTillResetRequestedFetchPrunesNodeIds,
  largeTreeNodeThreshold,
  rangeKeyIncrement,
  largeTreeRangeKeyIncrement,
  treeSessionId,
  defaultBackgroundTextureFileName,
  defaultDualPedigreeFrameStyle,
  defaultDualPedigreeTitleBorder,
  defaultDualPedigreeFontFamily,
  defaultZoomLevelValueForDualPedigree,
  forceFanChart,
  maxIdsPerRequest,
  maxConcurrentRequests,
  isPedigreeByURL,
  translatedLabels,
  // scalePrintCanvas,
  // fontArray,
} from '../library/constants';
import {
  fetchTreeError,
  setUnions,
  setBranches,
  setNodesObjs,
  setFanChartData,
  setFanChartUniqueChars,
  setWidthsNamesForFanchart,
  set_is_largetree,
  // setNodesObjsByNode,
  // setTest,
  setEdges,
  set_focusnode,
  set_cid_grps,
  set_firstTreeMatchCountNode,
  set_firstRecordMatchcCountNode,
  set_firstMaleGhostNode,
  set_firstFemaleGhostNode,
  set_firstTreeMatchNode,
  set_firstDeadNode,
  set_firstRecordMatchNode,
  set_firstSmartMatchNode,
  set_firstCycleMasterNode,
  set_firstMultipleParentNode,
  set_firstConflictNode,
  set_firstDNANode,

  set_firstEditNode,
  set_firstEmailRequestNode,
  set_firstInconsistentencyNode,
  set_firstMergePendingNode,
  set_firstAppear05Node,
  set_firstAppear06Node,
  set_firstAppear07Node,
  set_firstAppear08Node,
  set_firstAppear09Node,
  set_numOfGenerations,
  set_countOf,
  set_nodeobjsbyrange,
  setFlipData,
  setPreferences,
  // set_guide_page,
  setFloaters,
  set_legend_descriptions,
  setResolve,
  setProgressBarShow,
} from './actions';
import {
  getCanvasVars,
  buildNodeObj,
  getNodesWithManyUnions,
  reviseNodesObjForNodesWithManyUnions,
  deriveFetchTreeRangeCoordinates,
  assignMasterAndLengthToCycleClones,
  // getDummyText,
  buildRequestJsonPostOptions,
  // buildRequestMultiPartMimePostOptions,
  extractGhostNodes,
  getAddNodeObjFromUnions,
  buildDateAliveText,
  // derivePhotoBorderColor,
  augmentUnionArrayOfObjectsDerivedFromNodeObjs,
  changeForkBaseYPosForUnionsOfMultiplePartners,
  removeUnionsWithNoParents,
  // buildNameLineArray,
  addPedigreeCoordinates,
  setGenderForGhostNodes,
  buildImmediateFamily,
  designateNodesThatAreSeparated,
  // isMobilePhone,
  urlGet,
  buildImmediateFamilyObj,
  breakIdsIntoChunks,
  getNodeFromNodeObjsWithPid,
  augmentNodesObj,
  findFurthestEdges,
  buildNodeByRangeObjs,
  getNodeFromNodeObjsWithPrId,
  isEmpty,
  waterDefaultZoomLevelDualPed,
  adaptWidthFullnameArrrayForCustomFontsDualpedigree,
  encodeIfNeeded,
  prepareFanChart,
  breakChunksIntoGroups,
  countUniqueValues,
  getFontWidths,
  toUpper,
  // buildNameLineArray,
} from '../library/calc';
import {
  getChartType,
  getFocusPrId,
  getViewport,
  getGuide_page,
  // getProgress,
  // getNodeObjsByNode,
  getNodeObjs,
  getUnions,
  getFloaters,
  getIsPedigree,
  getIsDualPedigree,
  getDualPedigreeObj,
  // getDualPedigreeFocusRoot,
  getDualPedigreePosterId,
} from './selectors';
import request/*, { abortFetching }*/ from '../utils/request';

// import { dataFetchTree } from '../data/dataFetchTreeAmandaDualPedigree60.js';

/*

  FANCHART URLs

  Use this URL on:

    Dev: http://192.168.0.15:3000/13038?import=true&isFanChart=true
    Seinfeld: http://192.168.0.250:5000//family-tree/index/13038?isFanChart=true&afn=true
              http://192.168.0.250:5000//family-tree/index/46281?isFanChart=true&afn=true
    Stage: https://stage.geni.com/family-tree/index/324002769390004386?isFanChart=true&afn=true
           https://stage.geni.com/family-tree/index/6000000003075071669?isFanChart=true&afn=true Queen

 */

// import { dataFetchTreeNormalTree } from '../data/dataFetch13038.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetch60933.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetchTreeAmanda60Sm.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetchTree54b.js';
import { dataFetchTreeNormalTree } from '../data/dataFetchTreeHope.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetchNewUser.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetchElizabethLee.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetchRiszner.js';
import { dataFetchLegendDescriptions } from '../data/dataFetchLegendDescriptions.js';

// import { dataFetchTreeNormalTree } from '../data/dataFetchBiden.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetch6000000002410619032.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetch6000000204815287839.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetch13038Pedigree.js';
// import { dataFetchTree } from '../data/dataFetchFakePedigree2.js';
// import { dataFetchTree } from '../data/dataFetchFakePedigree3.js';  //
// import { dataFetchTree } from '../data/dataFetchFakePedigree6.js';  //
// import { dataFetchTree } from '../data/dataFetchFakePedigreeAmanda.js';  //
// import { dataFetchTree } from '../data/dataFetchFanChartBroke.js';  //
// import { dataFetchTree } from '../data/dataFetchFanChartBroke2.js';  //
// import { dataFetchTree } from '../data/dataFetchFanChart.js';  //
// import { dataFetchTree } from '../data/dataFetchTreeFocus.js';  //
import { dataFetchTree } from '../data/dataFetchFanChartAmandaTestTree.js';  //
// import { dataFetchTree } from '../data/dataFetchFanChartCycleSample.js';  //
// import { dataFetchTree } from '../data/dataFetchFanChartAmanda57.js';  //
// import { dataFetchTree } from '../data/dataFetchFanChartQueenTree.js';  //
// import { dataFetchTree } from '../data/dataFetchFanChartMikeTestTree.js';  //
// import { dataFlip } from '../data/dataFlipDana.js';  // Elizabeth Lee 6000000023252214790
import { dataFlip } from '../data/dataFlipHope.js';  // Elizabeth Lee 6000000023252214790
// import { dataFetchTree } from '../data/dataFetchFakePedigreeJames.js';  // Elizabeth Lee 6000000023252214790
// import { dataFetchTree } from '../data/dataFetchFanChartYao.js';  // Yao
// import { dataFetchTree } from '../data/dataFetchFanChartQueen.js';
// import { dataFetchTreeNormalTree } from '../data/dataFetch13038Pedigree.js';
// import { dataFetchTree } from '../data/dataFetchTreeAmanda60.js';
// import { dataFetchTree384410446520013712 } from '../data/dataFetchTreeDualPedigree384410446520013712.js';
// import { dataFetchTree } from '../data/dataFetchTree6000000001974931505.js';
// import { dataFetchTree } from '../data/dataFetchTreeAmandaDualPedigree60.js';
// import { dataFetchTree } from '../data/dataFetchTree6000000203631104908.js';
// import { dataFetchTree } from '../data/dataFetchTreeDualPedigree6000000192464416881.js';
// import { dataFlip } from '../data/dataFlip.js';
// import { dataFetchImmediate } from '../data/dataFetchImmediate.js';

const importedData = ( forceFanChart || dualPedigreeLaunchOnDev ? dataFetchTree: dataFetchTreeNormalTree);

// import notification from 'antd/lib/notification';

// import { fakeProfileImages } from './data/fakeProfileImages.js';

/**
 * Inorder to avoid flipdata from being overwritten from fetchProfiles we
 * must ensure fetchFlipDataSaga is fetched after fetchProfilesSaga
 * must delay fetchFlipDataSaga a moment for fetchProfilesSaga to finish
 */

let fetchedNodeObjPicsinQueue = [];
let fetchProfilesSagaIsBusy = false;
// let fetchingFloaters = false;
// let stop_inflight_sagas = false;
let endTimer = undefined
let startTimer = undefined
let lastedTime = undefined
let resetRequestedFetchPrunesTimeout = undefined
let requestedFetchProfilesNodeIds = [];
let requestedFetchPrunesNodeIds = [];

let spawnedTasks = [];
let setAllProfilesIsFetchedArray = [];
let fetchProfilesActionCallbackAllowComponentUpdateArray = [];
let fetchProfilesActionPostfetchArray = [];
let callRedrawArray = [];
let nnArray = [];
let dataFromFetchProfiles = [];
let idsLoadedCount = 0;
let percentLoadedOfFetchProfiles = 0;

export function* flushAllCallbackForFetchProfiles() {
  spawnedTasks = [];
  setAllProfilesIsFetchedArray = [];
  fetchProfilesActionCallbackAllowComponentUpdateArray = [];
  fetchProfilesActionPostfetchArray = [];
  fetchedNodeObjPicsinQueue = [];
  requestedFetchProfilesNodeIds = [];
  requestedFetchPrunesNodeIds = [];
  yield delay(0);
}

/*

startTimer = new Date().getTime();
endTimer = new Date().getTime();
lastedTime = endTimer - startTimer;
console.log('Fetching profiles took: ' + (lastedTime/1000) + ' secs');

 */

export function* fetchTreeSaga(fetchTreeAction) {

        // console.log(`fromWhere: `, fetchTreeAction.fromWhere);

/*
 *
 * if you add a param to fetch_tree called profile_data_ids and set it to the highlight pr_id,
 * then the response to fetch_tree will include the profile data for that highlight profile
 * better yet, call the param "h" and pass the highlight ID
 *
 * if that profile ID appears in multiple places in the tree (i.e. a cycle)
 * the one the server thinks is the highlight location comes back from fetch_tree with h=1
 *
 */
  // stop_inflight_sagas = true;
  if(typeof(window.resetSubscriptions) !== 'undefined' ) window.resetSubscriptions();
  yield fork(flushAllCallbackForFetchProfiles);

  let paramStrPrIdToTeleport = '';
  if(typeof(fetchTreeAction.prIdToTeleport) !== 'undefined'){
    const prIdToTeleport = fetchTreeAction.prIdToTeleport;
    paramStrPrIdToTeleport = `h=${prIdToTeleport}&`;
  }

  const viewport = yield select(getViewport());

  const canvasWidth = viewport.get('right');
  const canvasHeight = viewport.get('bottom');

  const coords = deriveFetchTreeRangeCoordinates({canvasWidth, canvasHeight});

  let focusPrId = yield select(getFocusPrId());

  let requestURL = `${host}/flash/fetch_tree?treeSessionId=${treeSessionId}&${paramStrPrIdToTeleport}profile=${focusPrId}&coords=${coords.toString()}&format=json`/* + getPedigreeChartStr*/;
  // console.count('fetchtree count');
  let isDualPedigree = yield select(getIsDualPedigree());
  // console.log(`dualPedigreeLaunchOnDev: `, dualPedigreeLaunchOnDev);
  let levels = urlGet('levels');
  if(( isDualPedigree && !dualPedigreeLaunchOnDev ) || ( forceFanChart && !dualPedigreeLaunchOnDev )) {
       // console.log(`%c fetchTreeAction.unionId: ${fetchTreeAction.unionId}`, [
       //   'color: white',
       //   'background: gray',
       //   'font-size: 14px',
       //   'border: 5px solid red',
       //   'padding: 10px',
       //   ].join(';'));

    let prune_ancestors = 3;
    let ahnentafel = false;
    if(forceFanChart){
      prune_ancestors = levels = urlGet('levels') ? urlGet('levels'): 8;
      ahnentafel = true;
    }
    // requestURL = `${host}/flash/fetch_tree/?poster=1&treeSessionId=${treeSessionId}&profile=${focusPrId}&ahnentafel=${ahnentafel}&format=json&walk_opts[walk_class]=dual_pedigree&walk_opts[prune_ancestors]=3&walk_opts[prune_descendants]=1&walk_opts[union_id]=${fetchTreeAction.unionId}&output_opts[chart_type]=horizontal&ids=all`;
    requestURL = `${host}/flash/fetch_tree/?poster=1&treeSessionId=${treeSessionId}&profile=${focusPrId}&ahnentafel=${ahnentafel}&format=json&walk_opts[walk_class]=dual_pedigree&walk_opts[prune_ancestors]=${prune_ancestors}&walk_opts[prune_descendants]=1&walk_opts[union_id]=${fetchTreeAction.unionId}&output_opts[chart_type]=horizontal&ids=all`;
  }
    console.log(`requestURL: `, requestURL);

   try {

    let data = (urlGet('import') === "true" ? importedData : yield call(request, requestURL));
    // let data = yield call(request, requestURL);
    // console.log(`data: `, JSON.stringify(data, null, 2));


    if(urlGet('export') === "true"){

      console.log(`data: `, JSON.stringify(data, null, 2));

    }

    if(typeof(data.success) !== 'undefined' && !data.success) {

      let messageObj = {
        type: 'info',
        content: data.error,
        title: data.title,
        duration: 3000,
      }

/*
    data.success = false;
    data.error = "This tree is taking too long to draw.  We've changed your preferences (gear icon at left) to reduce the number of ancestor and descendant generations.";
    data.title = "This request has timed out.";
    data.redraw = true;
    data.show_confirmation = true;
    data.geni_jsonx = true;

        let messageObj = {
          // type: 'error',
          content: data.error,
          title: data.title,
          duration: 5000,
        }

        if( typeof(data.show_confirmation) !== 'undefined' &&
            data.show_confirmation  &&
            typeof(data.redraw) !== 'undefined' &&
            data.redraw
        ){

          messageObj = {...{
            type: 'info',
            okLabel: 'Cancel',
            okCallback: ()=>{
              window.location.reload();
            },
            confirmLabel: 'Proceed',
            confirmCallback: ()=>{
              window.location.reload();
            },
            ...messageObj
          }};

          console.log(messageObj);

          window.callHookForMessageAlert(messageObj);

        } else {

          window.callHookForMessageAlert(messageObj);

        }

        window.callHideProgressIndicator();
*/

        window.callHookForMessageAlert(messageObj);

        if(typeof(data.redraw) !== 'undefined' && data.redraw ){
          yield delay(3000);
          window.location.reload();
          // window.callHideProgressIndicator();
          // window.destroyAtomNotification();
          // requestURL = `${host}/flash/fetch_tree?${paramStrPrIdToTeleport}profile=${data.redraw}&coords=${coords.toString()}&format=json`;
          // console.log(`requestURL: `, requestURL);
          // data = yield call(request, requestURL);
        }

        // return;

    }

    let chart_type = data.tree.metadata.preferences.chart_type;
    chart_type = chart_type === '' ? 'default': chart_type;

    if( dualPedigreeMode ) chart_type = 'horizontal';

    let prune_ancestors_num = data.tree.metadata.preferences.prune_ancestors_num;
    let max_ancestor_gen = data.tree.metadata.infos.max_ancestor_gen;

    // let max_descendant_gen = data.tree.infos.max_descendant_gen;
    // if( isDevelopment ) chart_type = 'fan';

    let isPedigree = ( chart_type === 'horizontal' ||
                      isDualPedigree ||
                      dualPedigreeLaunchOnDev ||
                      isPedigreeByURL  ||
                      dualPedigreeMode
                      ? true: false);
    let isFanChart = ( chart_type === 'fan' /*|| isDevelopment*/? true: false);
    if((isFanChart) || (isDevelopment && !isPedigreeByURL)) isPedigree = false;

    if( isPedigree ) yield put(setPreferences({ isPedigree }));
    if( isFanChart ) yield put(setPreferences({ isFanChart }));
    // console.log(`*** prune_ancestors_num: `, prune_ancestors_num);
    yield put(setPreferences({
      chartType: chart_type,
      maxAncestorGen: max_ancestor_gen,
      ancestors: prune_ancestors_num,
    }));

    let nodes = data.tree.nodes;
    const canvasVars = getCanvasVars(nodes);
    let nodeObjs = {};
    let fanChartData = undefined
    let nodeObjsArray = [];
    nnArray = [];
    let focusNode = undefined;
    let firstTreeMatchCountNode = undefined;
    let firstRecordMatchCountNode = undefined;

    let firstTreeMatchNode = undefined;
    let firstRecordMatchNode = undefined;
    let firstSmartMatchNode = undefined;
    let firstMaleGhostNode = undefined;
    let firstFemaleGhostNode = undefined;
    let firstCycleMaster = undefined;
    let firstMultipleParentNode = undefined;
    let firstConflictNode = undefined;
    let firstDNANode = undefined;
    let firstDeadNode = undefined;

    let firstEditNode = undefined;
    let firstEmailRequestNode = undefined;
    let firstInconsistentencyNode = undefined;
    let firstMergePendingNode = undefined;
    let firstAppear05Node = undefined;
    let firstAppear06Node = undefined;
    let firstAppear07Node = undefined;
    let firstAppear08Node = undefined;
    let firstAppear09Node = undefined;

    const nodecount = nodes.length;

    console.log(`Number of nodes: `, nodecount);

    let countOf = {};
    let hasPics = 0;
    let arrayOfTopValuesToDetermineTotalGenerations = [];
    let cidsGrps = [];
    nodes.forEach((_nodeObj) => {

      if(_nodeObj.focus === 1){
        focusNode = _nodeObj.n;
      }
      //node.nm = getDummyText(3);
      const nodeObj = buildNodeObj({ _nodeObj, ...canvasVars, isPedigree });
      nodeObjsArray.push(nodeObj);
      arrayOfTopValuesToDetermineTotalGenerations.push(nodeObj.top);
      const { n, dna, focus, e, g_e, m_p, tmn, rmn, d_r, g, nt, cyclemaster, tm, rm, sm, npu, inc, img} = nodeObj;
      if( typeof(nodeObj.cids) !== 'undefined' ){
        cidsGrps.push([nodeObj.n, parseInt(nodeObj.cids, 10) ]);
      }

      if( img.type === 'real' ){
        hasPics++;
      }

      if( typeof(tmn) !== 'undefined' || (urlGet('tmn') && parseInt(_nodeObj.n, 10) === parseInt(urlGet('tmn'), 10))){
      // if( _nodeObj.n === 64 ){
        firstTreeMatchCountNode = _nodeObj.n;
      }

      if( typeof(rmn) !== 'undefined' || (urlGet('rmn') && parseInt(_nodeObj.n, 10) === parseInt(urlGet('rmn'), 10))){
      // if( _nodeObj.n === ( isDevelopment ? 29190: 13)){
      // if( _nodeObj.n === ( isDevelopment ? 7: 13)){
        // firstRecordMatchCountNode =  urlGet('rmn');
        firstRecordMatchCountNode =  _nodeObj.n;
      }

      if( typeof(d_r) !== 'undefined' && g === 'm' && nt === 'ghost'){
      // if( _nodeObj.n === 8 ){
        firstMaleGhostNode = _nodeObj.n;
      }

      if( typeof(d_r) !== 'undefined' && g === 'f' && nt === 'ghost'){
      // if( _nodeObj.n === 8 ){
        firstFemaleGhostNode = _nodeObj.n;
      }

      if( typeof(tm) !== 'undefined' && parseInt(tm, 10) !== 0 && typeof(firstTreeMatchNode) === 'undefined' ){
        firstTreeMatchNode = _nodeObj.n;
      }

      if( typeof(rm) !== 'undefined' && parseInt(rm, 10) !== 0 &&  typeof(firstRecordMatchNode) === 'undefined' ){
      // if( _nodeObj.n === 8 ){
        firstRecordMatchNode = _nodeObj.n;
      }

      if( typeof(sm) !== 'undefined' && parseInt(sm, 10) !== 0 &&  typeof(firstSmartMatchNode) === 'undefined' ){
      // if( _nodeObj.n === 8 ){
        firstSmartMatchNode = _nodeObj.n;
      }

      if( typeof(npu) !== 'undefined' && parseInt(npu, 10) !== 0 &&  typeof(firstMultipleParentNode) === 'undefined' ){
      // if( _nodeObj.n === 9 ){
        firstMultipleParentNode = _nodeObj.n;
      }

      if( typeof(cyclemaster) !== 'undefined' &&  typeof(firstCycleMaster) === 'undefined' ){
        firstCycleMaster = cyclemaster;
      }

      if(typeof(firstConflictNode) === 'undefined' ){
      // if( _nodeObj.n === 9 ){
        firstConflictNode = _nodeObj.n;
      }

      if(typeof(dna) === 'undefined'  && typeof(firstDNANode) === 'undefined' ){
      // if( _nodeObj.n === 9 ){
        firstDNANode = _nodeObj.n;
      }

      if( _nodeObj.n === 15 ){
        firstDeadNode = _nodeObj.n;
      }

      if( typeof(e) !== 'undefined' && typeof(focus) === 'undefined' && parseInt(e, 10) !== 0 &&  typeof(firstEditNode) === 'undefined' ){
      // if( _nodeObj.n === 29 ){
        firstEditNode = _nodeObj.n;
      }

      if( typeof(g_e) !== 'undefined' && parseInt(g_e, 10) !== 0 &&  typeof(firstEmailRequestNode) === 'undefined' ){
      // if( _nodeObj.n === 30 ){
        firstEmailRequestNode = _nodeObj.n;
      }

      if( typeof(inc) !== 'undefined' && parseInt(inc, 10) !== 0 &&  typeof(firstInconsistentencyNode) === 'undefined' ){
      // if( _nodeObj.n === 16 ){
        firstInconsistentencyNode = _nodeObj.n;
      }

      if( typeof(m_p) !== 'undefined' && parseInt(m_p, 10) !== 0 &&  typeof(firstMergePendingNode) === 'undefined' ){
      // if( _nodeObj.n === 16 ){
        firstMergePendingNode = _nodeObj.n;
      }

      if(typeof(firstAppear05Node) === 'undefined' ){
      // if( _nodeObj.n === 9 ){
        // firstAppear05Node = _nodeObj.n;
      }

      if(typeof(firstAppear06Node) === 'undefined' ){
      // if( _nodeObj.n === 9 ){
        // firstAppear06Node = _nodeObj.n;
      }

      if(typeof(firstAppear07Node) === 'undefined' ){
      // if( _nodeObj.n === 9 ){
        // firstAppear07Node = _nodeObj.n;
      }

      if(typeof(firstAppear08Node) === 'undefined' ){
      // if( _nodeObj.n === 9 ){
        // firstAppear08Node = _nodeObj.n;
      }

      if(typeof(firstAppear09Node) === 'undefined' ){
      // if( _nodeObj.n === 9 ){
        // firstAppear09Node = _nodeObj.n;
      }

      nodeObjs[n] = nodeObj;
      if(typeof(nodeObj.nn) !== 'undefined' ) nnArray.push(nodeObj.nn);

      /*

        INSERT MOCK PICS HERE

        const picUrl = fakeProfileImages.shift();
        nodeObjs[n].t = picUrl;
        fakeProfileImages.push(picUrl);

       */



    });

    countOf = {hasPics};

    // console.log(`countOf: `, JSON.stringify(countOf, null, 2));

    assignMasterAndLengthToCycleClones(nodeObjs);

    let unions = data.tree.unions;

    // console.log(`unions: `, JSON.stringify(unions, null, 2));
    /*
    *
    *
    * Adding Pedigree Data
    *
    *
    */

    let uniqueFanChartChars;
    let hashWidthsNamesForFanchart;
    if( isPedigree ) {

      let obj = {};
      let leftBranches = [];
      let rightBranches = [];
      let titleName = undefined;
      let includeDate = undefined;

      if( isDualPedigree || dualPedigreeLaunchOnDev || dualPedigreeMode ){

        const hasPartner = typeof(data.tree.unions[0].p[1]) !== 'undefined';

        let dualPedigreeFocusRoot = {
          right: ( hasPartner ? data.tree.unions[0].p[1]: 0 ),
          left: data.tree.unions[0].p[0],
        }

        const dualPedigreeObj = yield select(getDualPedigreeObj());
        let dualPedigreeObjCopy = cloneDeep(dualPedigreeObj);

        dualPedigreeObjCopy = {...dualPedigreeObjCopy, root: dualPedigreeFocusRoot}

        yield put(setPreferences({ dualPedigreeObj: dualPedigreeObjCopy }));

        obj = addPedigreeCoordinates({nodeObjs, unions, focusPrId, isDualPedigree: true, dualPedigreeFocusRoot, side: 'left', dualPedigreeObj: dualPedigreeObjCopy});
        leftBranches = obj.branches;
        obj = addPedigreeCoordinates({nodeObjs, unions, focusPrId, isDualPedigree: true, dualPedigreeFocusRoot, side: 'right', dualPedigreeObj: dualPedigreeObjCopy});
        rightBranches = obj.branches;
        obj.branches = [...leftBranches, ...rightBranches];

        titleName = obj.titleName;

      } else {

        obj = addPedigreeCoordinates({nodeObjs, unions, focusPrId, isDualPedigree: false});

      }

      nodeObjs = obj.nodeObjs;
      nodeObjs = setGenderForGhostNodes({nodeObjs});

      yield put(setBranches(obj.branches));

      let newPrunesObj = {};
      for(var n in nodeObjs) {

        const nodeObj = nodeObjs[n];
        if(typeof(nodeObj.p) !== 'undefined') {
          newPrunesObj[nodeObj.pid] = n;
        }

      }

      if( dualPedigreeLaunchOnDev ){

        let custom = {
          "zoomLevelValue": defaultZoomLevelValueForDualPedigree,
          // shiftX:  0,
          // shiftY:  0,
        };

        for(let node in nodeObjs) {

          if(parseInt(node, 10) > 0){
            nodeObjs[node].dualPedigreeCustom = custom;
          }

        }

        yield put(setPreferences({ dualPedigreeObj: {
          frameStyle: defaultDualPedigreeFrameStyle,
          titleBorder: defaultDualPedigreeTitleBorder,
          fontFamily: defaultDualPedigreeFontFamily,
          backgroundTextureFileName: defaultBackgroundTextureFileName,
          titleName,
          includeDate: true,
          whichChildrenNode: 0,
        } }));
      }


      if( isDualPedigree && !dualPedigreeLaunchOnDev){

        let posterData = undefined;
        let customObjs = undefined;

        const tpId = yield select(getDualPedigreePosterId());



        if( tpId !== -1 ){

          const results = yield call(postPoster, {action: 'load', tpId});
          posterData = results.data

          customObjs = posterData.customObjs;
          const isNewPoster = isEmpty(customObjs);

          let custom = undefined;
          if( !isNewPoster){

                  // console.log(`%c not NewPoster`, [
                  // 'color: white',
                  // 'background: blue',
                  // 'font-size: 14px',
                  // 'border: 5px solid red',
                  // 'padding: 10px',
                  // ].join(';'));
            for( var prId in customObjs){
              custom = customObjs[prId];
              const node = getNodeFromNodeObjsWithPrId({nodeObjs, prId});
              if( typeof(node) !== 'undefined' ) nodeObjs[node].dualPedigreeCustom = custom;  // printTreeResolution Tweak
            }

            nodeObjs = waterDefaultZoomLevelDualPed({nodeObjs});

          } else {

            nodeObjs = waterDefaultZoomLevelDualPed({nodeObjs});

          }

          const frameStyle = results.data.frameStyle;
          const backgroundTextureFileName = results.data.backgroundTextureFileName;
          const titleBorder = results.data.titleBorder;
          const fontFamily = results.data.fontFamily;
          if(typeof(results.data.titleName) !== 'undefined' ) titleName = decodeURIComponent(decodeURI(results.data.titleName));
          if(typeof(results.data.includeDate) !== 'undefined' ) includeDate = results.data.includeDate;
          let whichChildrenNode = ( typeof(results.data.whichChildrenNode) !== 'undefined' ? results.data.whichChildrenNode: 0);


          const dualPedigreeObj = yield select(getDualPedigreeObj());
          let dualPedigreeObjCopy = cloneDeep(dualPedigreeObj);

          // console.log(`{frameStyle, backgroundTextureFileName, titleBorder,  fontFamily}: `, JSON.stringify({frameStyle, backgroundTextureFileName, titleBorder, fontFamily}, null, 2));

          dualPedigreeObjCopy = {...dualPedigreeObjCopy, frameStyle, backgroundTextureFileName, titleBorder, fontFamily, titleName, includeDate, whichChildrenNode}
          nodeObjs = adaptWidthFullnameArrrayForCustomFontsDualpedigree({nodeObjs, fontFamily});

          yield put(setPreferences({ dualPedigreeObj: dualPedigreeObjCopy }));


        } else {
          console.log('No poster data to retrieve.');

          const dualPedigreeObj = yield select(getDualPedigreeObj());
          let dualPedigreeObjCopy = cloneDeep(dualPedigreeObj);
          dualPedigreeObjCopy = {...dualPedigreeObjCopy, titleName}

          yield put(setPreferences({ dualPedigreeObj: dualPedigreeObjCopy }));

          nodeObjs = waterDefaultZoomLevelDualPed({nodeObjs});
          nodeObjs = adaptWidthFullnameArrrayForCustomFontsDualpedigree({nodeObjs, fontFamily: dualPedigreeObjCopy.fontFamily});
        }

      }

      const target_ids = [];
      for (const pid in newPrunesObj) {
        if (newPrunesObj.hasOwnProperty(pid)) {
          target_ids.push(pid);
        }
      }

      nodeObjs = designateNodesThatAreSeparated({ unions, nodeObjs })

    } else if(chart_type === 'fan'){

      let uniqueAllNamesArray = [];
      const nodes = data.tree.nodes.map(obj => {
        uniqueAllNamesArray.push(obj.nm);
        return {
          fn: obj.fn,
          ln: obj.ln,
          nm: obj.nm,
          // nm: 'John Doe John Doe',
          pr_id: obj.pr_id,
          pid: obj.pid,
          g: obj.g,
          n: obj.n,
          ahn: obj.ahn,
          dob_c: obj.dob_c,
          dob_y: obj.dob_y,
          dod_c: obj.dod_c,
          dod_y: obj.dod_y,
          l: obj.l,
          // dob_c: '1991',
          // dob_y: '1991',
          // dod_c: '1991',
          // dod_y: '1991',
        };
      });

      uniqueAllNamesArray.push(toUpper(translatedLabels['Add father'].translatedLabel));
      uniqueAllNamesArray.push(toUpper(translatedLabels['Add mother'].translatedLabel));

      const specialCharacters = "!@#$%^&*()_-+={}[]|;:,.<>?/~`";

      uniqueFanChartChars = [...new Set([
        ...uniqueAllNamesArray.flatMap(word => [...word].map(c => String(c))),
        ...Array.from({length: 10}, (_, i) => i.toString()),
        ...[...specialCharacters].map(c => String(c).toLowerCase())
      ])];

      hashWidthsNamesForFanchart = getFontWidths({uniqueFanChartChars, fontName: 'Open Sans', fontSize:  24})

      // const hashTable = data.tree.nodes.reduce((acc, { pr_id, nm, n, ahn }) => {
      //   acc[pr_id] = { nm, n, ahn };
      //   return acc;
      // }, {});

      // console.log(`hashTable: `, JSON.stringify(hashTable, null, 2));

      data.tree.nodes = nodes;

      delete data.tree.metadata;

      const { tree } = data;

      let newData = { ...tree };

      fanChartData = prepareFanChart(nodes[0].n, newData);

      let addFatherStr = 'Add father'
      let addMotherStr = 'Add mother'
      addFatherStr = '+'
      addMotherStr = '+'

      if( fanChartData.parents.length === 1 ){

          if(fanChartData.parents[0].node.g === 'f'){

              fanChartData.parents.unshift({
                "node": {
                  "nm": addFatherStr,
                  lastGhostParent: true,
                  "g": "m",
                  "ahn": '2',
                  childNode: fanChartData.node
                },
                "parents": []
              })

          } else {

              fanChartData.parents.push({
                "node": {
                  "nm": addMotherStr,
                  lastGhostParent: true,
                  "g": "f",
                  "ahn": '3',
                  childNode: fanChartData.node
                },
                "parents": []
              })

          }

      } else if(fanChartData.parents.length === 0 || typeof(fanChartData.parents) === 'undefined' ){

          fanChartData.parents.push({
            "node": {
              "nm": addFatherStr,
              lastGhostParent: true,
              "g": "m",
              "ahn": '2',
              childNode: fanChartData.node
            },
            "parents": []
          })

          fanChartData.parents.push({
            "node": {
              "nm": addMotherStr,
              lastGhostParent: true,
              "g": "f",
              "ahn": '3',
              childNode: fanChartData.node
            },
            "parents": []
          })

      }


      // yield delay(3000);

    } else {

      unions = removeUnionsWithNoParents(unions);

      const nodesWithManyUnions = getNodesWithManyUnions(unions);
      window.nodesWithManyUnions = nodesWithManyUnions;

      reviseNodesObjForNodesWithManyUnions({ nodesWithManyUnions, nodeObjs });

      unions = augmentUnionArrayOfObjectsDerivedFromNodeObjs({unions, nodeObjs, nodesWithManyUnions});

      window.unionCalcObj = changeForkBaseYPosForUnionsOfMultiplePartners({unions, nodeObjs, nodesWithManyUnions});

      unions.sort((a,b) => { // Lines are sorted with longest on top
          var x = a.length > b.length? -1:1;
          return x;
      });

    }

    /*
    *
    *
    * Adding Ghost Spouse Object
    *
    *
    */

    const ghostsNodes = extractGhostNodes(nodes);
    const addNodeObjsCopy = cloneDeep(nodeObjs);

    ghostsNodes.forEach((ghostsNode) => {
      const addNodeObj = getAddNodeObjFromUnions({ghostsNode, unions, addNodeObjsCopy})
      nodeObjs[ghostsNode].addNodeObj = addNodeObj;
    })


    const fromWhere = 'fetchTreeSaga';

    nodeObjsArray = sortBy(nodeObjsArray, obj=>obj.left);
    const edgesObj = findFurthestEdges( { nodeObjsArray } );

    const furthestRight = edgesObj.right;
    let nodeObjsByRange = undefined;
    if(isFanChart) {
      yield put(set_focusnode( focusNode, fromWhere));
      yield put(set_cid_grps( cidsGrps, fromWhere));
      yield put(setFanChartData(fanChartData, fromWhere));
      yield put(setFanChartUniqueChars(uniqueFanChartChars, fromWhere));
      yield put(setWidthsNamesForFanchart(hashWidthsNamesForFanchart, fromWhere));
      yield put(setNodesObjs(nodeObjs, fromWhere));
      yield put(set_is_largetree({isLargeTree: false, nodecount}, fromWhere));
      yield put(setPreferences({ fanchartObj: {
        levels,
      } }));
      if(typeof(fetchTreeAction.callback) !== 'undefined'){ fetchTreeAction.callback();}
      return;
    }
    if( nodecount > largeTreeNodeThreshold) {
      yield put(setProgressBarShow(true)); // Setting large tree to percent loaded = 0 to incomplete navigation goto list
      yield put(set_is_largetree({isLargeTree: true, nodecount}, fromWhere));
      nodeObjsByRange = buildNodeByRangeObjs({nodeObjsArray, furthestRight, rangeKeyIncrement: largeTreeRangeKeyIncrement});
    } else {
      yield put(set_is_largetree({isLargeTree: false, nodecount}, fromWhere));
      nodeObjsByRange = buildNodeByRangeObjs({nodeObjsArray, furthestRight, rangeKeyIncrement});
    }
    yield put(setEdges( edgesObj, fromWhere));
    yield put(set_focusnode( focusNode, fromWhere));
    yield put(set_cid_grps( cidsGrps, fromWhere));
    yield put(set_firstTreeMatchCountNode( firstTreeMatchCountNode, fromWhere));
    yield put(set_firstRecordMatchcCountNode( firstRecordMatchCountNode, fromWhere));
    yield put(set_firstMaleGhostNode( firstMaleGhostNode, fromWhere));
    yield put(set_firstFemaleGhostNode( firstFemaleGhostNode, fromWhere));
    yield put(set_firstTreeMatchNode( firstTreeMatchNode, fromWhere));
    yield put(set_firstDeadNode( firstDeadNode, fromWhere));
    yield put(set_firstRecordMatchNode( firstRecordMatchNode, fromWhere));
    yield put(set_firstSmartMatchNode( firstSmartMatchNode, fromWhere));
    yield put(set_firstCycleMasterNode( firstCycleMaster, fromWhere));
    yield put(set_firstMultipleParentNode( firstMultipleParentNode, fromWhere));
    yield put(set_firstConflictNode( firstConflictNode, fromWhere));
    yield put(set_firstDNANode( firstDNANode, fromWhere));

    yield put(set_firstEditNode( firstEditNode, fromWhere));
    yield put(set_firstEmailRequestNode( firstEmailRequestNode, fromWhere));
    yield put(set_firstInconsistentencyNode( firstInconsistentencyNode, fromWhere));
    yield put(set_firstMergePendingNode( firstMergePendingNode, fromWhere));
    yield put(set_firstAppear05Node( firstAppear05Node, fromWhere));
    yield put(set_firstAppear06Node( firstAppear06Node, fromWhere));
    yield put(set_firstAppear07Node( firstAppear07Node, fromWhere));
    yield put(set_firstAppear08Node( firstAppear08Node, fromWhere));
    yield put(set_firstAppear09Node( firstAppear09Node, fromWhere));


    const numOfGenerations = countUniqueValues(arrayOfTopValuesToDetermineTotalGenerations);
    yield put(set_numOfGenerations( numOfGenerations, fromWhere));

    let scaleOfMiniMap = .22;
    if( numOfGenerations > 10 ) scaleOfMiniMap = .18;
    if( numOfGenerations > 15 ) scaleOfMiniMap = .15;
    if( numOfGenerations > 19 ) scaleOfMiniMap = .08;

    let lowerPrintRes = false; // printTreeResolution SuperTweak
    let scalePrintCanvas = 2.4;
    if( numOfGenerations > 14 ){
      lowerPrintRes = true;
      scalePrintCanvas = 1.8;
    }

    yield put(setPreferences({
      scalePrintCanvas,
      scaleOfMiniMap,
      lowerPrintRes,
    }));


    yield put(set_countOf( countOf, fromWhere));
    yield put(set_nodeobjsbyrange( nodeObjsByRange, fromWhere));
    yield put(setNodesObjs(nodeObjs, fromWhere));
    yield put(setUnions(unions));

    if(typeof(window.subscribeProfileUpdates) !== 'undefined' ){
      if( nnArray.length > 0) window.subscribeProfileUpdates(nnArray);
    }
    if(typeof(fetchTreeAction.callback) !== 'undefined'){ fetchTreeAction.callback(nodeObjs);}

  } catch (err) {
    console.log(err);
    console.log(`err: `, JSON.stringify(err, null, 2));

    if( typeof(err.SyntaxError) !== 'undefined') {
      let  messageObj = {
        type: 'error',
        content: err.SyntaxError,
        title: 'An error has occurred.',
        duration: 5000,
      }
      window.callHookForMessageAlert(messageObj);
      window.callHideProgressIndicator();
    }

    yield put(fetchTreeError(err));

  }
}

export function* fetchLegendDescriptions({focusPrId}) {

  // console.log(`focusPrId: `, focusPrId);
  // const requestURL = `${host}/https://stage.geni.com/family-tree/legend_descriptions?profile=${focusPrId}&format=json`;

  if( !isDevelopment) {
    const requestURL = `${host}/family-tree/legend_descriptions`;
    dataFetchLegendDescriptions = yield call(request, requestURL);
  } else {

  }
  // console.log(`dataFetchLegendDescriptions: `, JSON.stringify(dataFetchLegendDescriptions, null, 2));
  yield put(set_legend_descriptions(dataFetchLegendDescriptions));


}

export function* fetchImmediateFamilySaga({focusPrId, focusNodeId, focusGender, afterFetch, forWhat}) {

  // console.log(`focusPrId: `, focusPrId);

  let resolveDuplicatesString = ''
  if(forWhat === 'resolveDuplicates'){
    resolveDuplicatesString = '&resolve_duplicates=true&check_partner_conflicts=true';
  }

  const requestURL = `${host}/flash/fetch_immediate_family?treeSessionId=${treeSessionId}&profile=${focusPrId}${resolveDuplicatesString}&format=json`;

  // console.log(`requestURL: `, requestURL);

  try {

    var data = yield call(request, requestURL);
    // var data = ( urlGet('import') === "true" ? dataFetchImmediate: data);

    if(urlGet('export') === "true") console.log(`data: `, JSON.stringify(data, null, 2));

    window.thisData = data;

    const unions = data.tree.unions;

    const nodes = data.tree.nodes;

    const requested_merges = data.tree.metadata.requested_merges;

    let lookUpNodeId = {};
    let lookUpPrId = {};

    if(forWhat === 'resolveDuplicates'){

      const shrinkEachWordInNameBy8 = ({nm}) =>{
        let nmArray = nm.split(" ");
        const newNmArray = nmArray.map((nmPartial, idx) => {
          if (nmPartial.length > 11) {
            nmPartial = nmPartial.substring(0, 8) + '...';
          }
          return nmPartial;
        });
        return newNmArray.join(" ");
      }

      nodes.forEach((obj) => {

        const { n, pr_id, t, g, fn, ln, nvp, a, e, dob_c, dod_c, dob_y, dod_y, l, focus } = obj;
        let { nm } = obj;
        lookUpNodeId[pr_id] = n;

        const dateAlive = buildDateAliveText({dob_c, dod_c, dob_y, dod_y, l})

        nm = shrinkEachWordInNameBy8({nm});

        lookUpPrId[n] = {
          prId: pr_id,
          pr_id,
          focus,
          n,
          nm,
          t,
          g,
          fn,
          ln,
          nvp,
          a,
          e,
          dateAlive,
        };
      });

      const {parents, siblings, children, partners } = buildImmediateFamily({focusPrId, lookUpPrId, lookUpNodeId, unions, sortByGender:true});

      const resolveHasNodesToResolve = () => {
        return parents.length > 1 ||
        children.length > 1 ||
        partners.length > 1 ||
        siblings.length > 1
      }

      yield put(setResolve({focusPrId, parents, siblings, children, partners}));

      if(typeof(afterFetch) !== 'undefined') afterFetch({resolveHasNodesToResolve, requested_merges});

    }


    if(forWhat === 'pedgreeAddbox' ||
       forWhat === 'parentChooser' ||
       forWhat === 'siblingChooser' ||
       forWhat === 'fanchart'
    ){

      const nodeObjsOrig = yield select(getNodeObjs());
      const nodeObjsCopy = cloneDeep(nodeObjsOrig);
      const immediateFamObj = buildImmediateFamilyObj({nodes, unions, lookUpPrId, lookUpNodeId, focusPrId, focusGender})
      nodeObjsCopy[focusNodeId].immediateFam = immediateFamObj;

      const fromWhere = 'fetchImmediateFamilySaga';
      yield put(setNodesObjs(nodeObjsCopy, fromWhere));
      if(typeof(afterFetch) !== 'undefined') afterFetch({partners: immediateFamObj.partners, allPotentialParentPairs: immediateFamObj.allPotentialParentPairs});

    }


  } catch (err) {
    console.log(`err: `, err);
    yield put(fetchTreeError(err));
  }

  yield delay(1000);
}


export function* cancelAllSpawnedFetchProfilesSaga(cancelAllSpawnedFetchProfilesSagaAction) {
  yield fork(spawnFetchProfiles, {cancelIt: true});
}

export function* spawnFetchProfiles(fetchProfilesAction) {
  if( debugWiderCatchForFetchProfiles ) console.log('<<<< spawnFetchProfiles >>>>');

  const setAllProfilesIsFetched = fetchProfilesAction.setAllProfilesIsFetched;
  setAllProfilesIsFetchedArray.push( typeof(fetchProfilesAction.setAllProfilesIsFetched) === 'function' ? setAllProfilesIsFetched: undefined);

  const callbackAllowComponentUpdate = fetchProfilesAction.callbackAllowComponentUpdate;
  fetchProfilesActionCallbackAllowComponentUpdateArray.push( typeof(fetchProfilesAction.callbackAllowComponentUpdate) === 'function' ? callbackAllowComponentUpdate: undefined);

  const callRedraw = fetchProfilesAction.callRedraw;
  callRedrawArray.push( typeof(fetchProfilesAction.callRedraw) === 'function' ? callRedraw: undefined);

  const postfetch = fetchProfilesAction.postfetch;
  fetchProfilesActionPostfetchArray.push( typeof(fetchProfilesAction.postfetch) === 'function' ? postfetch: undefined);

  if(typeof(fetchProfilesAction.cancelIt) !== 'undefined'){

    let spawnedTask = undefined;
    while(spawnedTasks.length > 0){
      spawnedTask = spawnedTasks.pop();
      if(typeof(spawnedTask) !== 'undefined'){
        yield cancel(spawnedTask);
      }
    }
    return;
  }

  const spawnedTask = yield spawn(fetchProfilesInChunksSaga, fetchProfilesAction);
  spawnedTasks.push(spawnedTask);
}

function* processGroup(group, fetchFocusPrId, fetchProfilesAction, totalNumberOfIdsToFetch, maxIdsPerRequest) {

  for (let j = 0; j < group.length; j++) {
    const chunks = group[j];
    const chunksLength = chunks.length
    // console.log(`chunks: `, JSON.stringify(chunks, null, 2));
      const requestURL = `${host}/flash/fetch_profiles?treeSessionId=${treeSessionId}&profile=${fetchFocusPrId}&ids=${chunks.toString()}&format=json`;
      // console.log(`requestURL: `, requestURL);
      const options = {
        callback: (response) => {
          idsLoadedCount += chunksLength;
          percentLoadedOfFetchProfiles = Math.round((idsLoadedCount / totalNumberOfIdsToFetch ) * 100);
          if (typeof(fetchProfilesAction.callbackSetProgressBar) !== 'undefined') fetchProfilesAction.callbackSetProgressBar(percentLoadedOfFetchProfiles);
          return response;
        }
      }
      const data = yield call(request, requestURL, options);
      dataFromFetchProfiles.push(data);
  }
}

function* fetchProfilesInChunksSaga(fetchProfilesAction) {

    fetchProfilesSagaIsBusy = true;

    const fetchFocusPrId = yield select(getFocusPrId());
    const newProfilesObj = fetchProfilesAction.newProfilesObj;
    const ids = [];
    idsLoadedCount = 0;

    let pid = null;
    for (pid in newProfilesObj) {
      if (newProfilesObj.hasOwnProperty(pid)) {
        const nodeId = newProfilesObj[pid];
        if (!requestedFetchProfilesNodeIds.includes(nodeId)) {
          ids.push(pid);
        }
        requestedFetchProfilesNodeIds.push(nodeId);
      }
    }

    if( typeof(maxIdsPerRequest) === 'undefined' ) maxIdsPerRequest = 50;
    if( typeof(maxConcurrentRequests) === 'undefined' ) maxConcurrentRequests = 6;

       // console.log(`%c maxIdsPerRequest ${maxIdsPerRequest}`, [
       //   'color: white',
       //   'background: red',
       //   'font-size: 14px',
       //   'border: 5px solid red',
       //   'padding: 10px',
       //   ].join(';'));

       // console.log(`%c maxConcurrentRequests ${maxConcurrentRequests}`, [
       //   'color: white',
       //   'background: red',
       //   'font-size: 14px',
       //   'border: 5px solid red',
       //   'padding: 10px',
       //   ].join(';'));

    const totalNumberOfIdsToFetch = ids.length;
    const chunks = breakIdsIntoChunks({ ids, chunkLength: maxIdsPerRequest });
    const groups = breakChunksIntoGroups({chunks, groupLength: ( (chunks.length/maxConcurrentRequests)) + 1 });

    dataFromFetchProfiles = [];

    if (typeof (fetchProfilesAction.prefetch) === 'function') fetchProfilesAction.prefetch();

    if (typeof (fetchProfilesAction.callbackSetProgressBar) !== 'undefined') yield put(setProgressBarShow(true));

    try {

      /*
          Spawn  mutiple threads

       */

      const groupSagas = groups.map(group => call(processGroup, group, fetchFocusPrId, fetchProfilesAction, totalNumberOfIdsToFetch, maxIdsPerRequest));
      yield all(groupSagas);

      if (typeof (fetchProfilesAction.callbackSetProgressBar) !== 'undefined' && percentLoadedOfFetchProfiles === 100){
        yield put(setProgressBarShow(false));
        percentLoadedOfFetchProfiles = 0;
      }

      if( typeof(dataFromFetchProfiles) !== 'undefined' && typeof(newProfilesObj) !== 'undefined' ) yield fork(queueFetchedProfilesData, { dataFromFetchProfiles, newProfilesObj });
      if (typeof (fetchProfilesAction.releaseQueueOfFetchedProfilesData) !== 'undefined') {
        yield fork(releaseQueueOfFetchedProfilesData);
      }

    } finally {

        if (yield cancelled()) {
          console.log('<<<<< cancelled called >>>>>');
        }

    }
}


/*

function* fetchProfilesInChunksSaga(fetchProfilesAction_one_thread) {
  try {
    fetchProfilesSagaIsBusy = true;

    const fetchFocusPrId = yield select(getFocusPrId());
    const newProfilesObj = fetchProfilesAction.newProfilesObj;
    const ids = [];

    let pid = null;
    for (pid in newProfilesObj) {
      if (newProfilesObj.hasOwnProperty(pid)) {
        const nodeId = newProfilesObj[pid];
        if (!requestedFetchProfilesNodeIds.includes(nodeId)) {
          ids.push(pid);
        }
        requestedFetchProfilesNodeIds.push(nodeId);
      }
    }

    const chunkLength = 12;
    const chunks = breakIdsIntoChunks({ ids, chunkLength });
    const chunksLength = chunks.length;
    let idsLoadedCount = 0;

    if (typeof (fetchProfilesAction.prefetch) === 'function') fetchProfilesAction.prefetch();

    if (typeof (fetchProfilesAction.callbackSetProgressBar) !== 'undefined') yield put(setProgressBarShow(true));

    let datas = [];

    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i];
      const requestURL = `${host}/flash/fetch_profiles?treeSessionId=${treeSessionId}&profile=${fetchFocusPrId}&ids=${chunk.toString()}&format=json`;
      const options = {
        callback: (response) => {
          idsLoadedCount++;
          const percentLoadedOfFetchProfiles = Math.round((idsLoadedCount / chunksLength) * 100);
          if (typeof (fetchProfilesAction.callbackSetProgressBar) !== 'undefined') fetchProfilesAction.callbackSetProgressBar(percentLoadedOfFetchProfiles);
          return response;
        }
      }
      const data = yield call(request, requestURL, options);
      datas.push(data);
    }

    if (typeof (fetchProfilesAction.callbackSetProgressBar) !== 'undefined') yield put(setProgressBarShow(false));
    idsLoadedCount = 0;

    yield fork(queueFetchedProfilesData, { datas, newProfilesObj });
    if (typeof (fetchProfilesAction.releaseQueueOfFetchedProfilesData) !== 'undefined') {
      yield fork(releaseQueueOfFetchedProfilesData);
    }

  } finally {
    if (yield cancelled()) {
      console.log('<<<<< cancelled called >>>>>');
    }
  }
}

function* fetchProfilesInChunksSaga(fetchProfilesAction_multiple_threads) { // OLD WAY

  try {

    fetchProfilesSagaIsBusy = true;

    const fetchFocusPrId = yield select(getFocusPrId());
    const newProfilesObj = fetchProfilesAction.newProfilesObj;
    const ids = [];

    let pid = null;
    for (pid in newProfilesObj) {
      if (newProfilesObj.hasOwnProperty(pid)) {
        const nodeId = newProfilesObj[pid];
        if( !requestedFetchProfilesNodeIds.includes(nodeId)){
          ids.push(pid);
        }
        requestedFetchProfilesNodeIds.push(nodeId);
      }
    }

    if(debugWiderCatchForFetchProfiles){
      console.log(`ids: `, JSON.stringify(ids, null, 2));
    }

    const chunkLength = 12;
    const chunks = breakIdsIntoChunks({ids, chunkLength});
    const chunksLength = chunks.length;
    let idsLoadedCount = 0;

    if(debugWiderCatchForFetchProfiles) console.log(`chunks: `, JSON.stringify(chunks, null, 2));

    if(typeof(fetchProfilesAction.prefetch) === 'function') fetchProfilesAction.prefetch();

    if(typeof(fetchProfilesAction.callbackSetProgressBar) !== 'undefined' ) yield put(setProgressBarShow(true));

    const callRequestArray = chunks.map((chunk) => {
      const requestURL = `${host}/flash/fetch_profiles?treeSessionId=${treeSessionId}&profile=${fetchFocusPrId}&ids=${chunk.toString()}&format=json`;
      const options = {
        callback: (response) => {
          idsLoadedCount++;
          const percentLoadedOfFetchProfiles = Math.round(( idsLoadedCount / chunksLength ) * 100);
          if(typeof(fetchProfilesAction.callbackSetProgressBar) !== 'undefined' ) fetchProfilesAction.callbackSetProgressBar(percentLoadedOfFetchProfiles);
          return response;
        }
      }
      return call(request, requestURL, options);
    })

    if(debugWiderCatchForFetchProfiles){
      startTimer = new Date().getTime();
    }
    let datas = undefined;

    datas = yield all([...callRequestArray]);
    if(typeof(fetchProfilesAction.callbackSetProgressBar) !== 'undefined' ) yield put(setProgressBarShow(false));
    idsLoadedCount = 0;

    if(debugWiderCatchForFetchProfiles){
      endTimer = new Date().getTime();
      lastedTime = endTimer - startTimer;
      console.log('server batch fetchProfiles took: ' + (lastedTime/1000) + ' secs');
    }
// console.log(`datas: `, JSON.stringify(datas, null, 2));
    yield fork(queueFetchedProfilesData, {datas, newProfilesObj});
    if(typeof(fetchProfilesAction.releaseQueueOfFetchedProfilesData) !== 'undefined'){
      if(debugWiderCatchForFetchProfiles) console.log(' <<<<<<<<< releaseQueueOfFetchedProfilesData >>>>>');
      yield fork(releaseQueueOfFetchedProfilesData);
    }
    return;

  } finally {
    if (yield cancelled()){
      console.log('<<<<< cancelled called >>>>>');
    }
  }

}

*/

/*
  fetchedProfilesDatas = [
    {
      nodes,
      newProfilesObj,
    },
  ]
 */

let fetchedProfilesDatas = [];
function* queueFetchedProfilesData({ dataFromFetchProfiles, newProfilesObj }) {
  fetchedProfilesDatas.push({ dataFromFetchProfiles, newProfilesObj });
  yield delay(0);
}

function* releaseQueueOfFetchedProfilesData() {

  let combinedDatas = [];
  let combinedNewProfilesObj = {};

  for (let i = 0; i < fetchedProfilesDatas.length; ++i) {
    const { dataFromFetchProfiles, newProfilesObj } = fetchedProfilesDatas[i];
    combinedDatas.push(...dataFromFetchProfiles);
    combinedNewProfilesObj = {...combinedNewProfilesObj, ...newProfilesObj};
  };

  if(combinedDatas.length > 0) {
    if(debugWiderCatchForFetchProfiles) console.log(`SaveFetchedProfilesData - fetchedProfilesDatas.length: `, fetchedProfilesDatas.length);
    yield fork(
      saveFetchedProfilesData,
      {
        datas: combinedDatas,
        newProfilesObj: combinedNewProfilesObj,
      },
    )
  } else {
    if(debugWiderCatchForFetchProfiles) console.log(`Skip saveFetchedProfilesData. Nothing to release. CombinedDatas.length: `, combinedDatas.length);
  }
}

export function* releaseQueueFetchedProfilesSaga() {
  yield fork(releaseQueueOfFetchedProfilesData);
}

function* saveFetchedProfilesData({datas, newProfilesObj}) {

  let startTimerSaveFetchedProfilesData = undefined;
  if(debugWiderCatchForFetchProfiles){
    startTimerSaveFetchedProfilesData = new Date().getTime();
  }

  let nodes = []
  datas.forEach((data)=>{
    nodes.push(...data.tree.nodes);
  });

  if(debugWiderCatchForFetchProfiles){
    const pidsReleased = nodes.map(node=>node.pid);
    console.log(`pidsReleased: `, JSON.stringify(pidsReleased, null, 2));
  }

  let nodeObjsCopy = null;
  let nodeObjsBundle = null;
  let firstTreeMatchCountNode = undefined;
  let firstRecordMatchCountNode = undefined;

  const unions = yield select(getUnions());

  const fetchFocusPrId = yield select(getFocusPrId());

  const nodeObjsOrig = yield select(getNodeObjs());

  nodeObjsCopy = cloneDeep(nodeObjsOrig);

  nnArray = [];

  nodes.forEach((obj) => {
    // nodeObjsCopy = augmentNodesObj( {newProfilesObj, nodeObjsCopy, obj } );
    if(typeof(obj.nn) !== 'undefined' ) nnArray.push(obj.nn);
    const n = newProfilesObj[obj.pid];
    if(typeof(nodeObjsCopy[n]) !== 'undefined'){
      if(typeof(nodeObjsCopy[n].cyclemaster) !== 'undefined'){
        const nodeNumbers = getNodeFromNodeObjsWithPid({nodeObjs: nodeObjsCopy, pid: obj.pid, fromWhere: 'saveFetchedProfilesData'});
        nodeNumbers.forEach((nodeNumber)=>{
          nodeObjsBundle = augmentNodesObj( {n: nodeNumber, newProfilesObj, nodeObjsCopy, obj } );
          nodeObjsCopy = nodeObjsBundle.nodeObjsCopy;
          if(typeof(firstTreeMatchCountNode) === 'undefined') firstTreeMatchCountNode = nodeObjsBundle.firstTreeMatchCountNode;
          if(typeof(firstRecordMatchCountNode) === 'undefined') firstRecordMatchCountNode = nodeObjsBundle.firstRecordMatchCountNode;
        });
      } else {
        nodeObjsBundle = augmentNodesObj( {n, newProfilesObj, nodeObjsCopy, obj} );
        nodeObjsCopy = nodeObjsBundle.nodeObjsCopy;
          if(typeof(firstTreeMatchCountNode) === 'undefined') firstTreeMatchCountNode = nodeObjsBundle.firstTreeMatchCountNode;
          if(typeof(firstRecordMatchCountNode) === 'undefined') firstRecordMatchCountNode = nodeObjsBundle.firstRecordMatchCountNode;
      }
    }

  })

  if(typeof(window.subscribeProfileUpdates) !== 'undefined' ){
    if( nnArray.length > 0) window.subscribeProfileUpdates(nnArray);
  }

  /*
  *
  *
  * Adding Ghost Spouse Object
  *
  *
  */

  const ghostsNodes = extractGhostNodes(nodes);
  const addNodeObjsCopy = cloneDeep(nodeObjsCopy);

  ghostsNodes.forEach((ghostsNode) => {
    const addNodeObj = getAddNodeObjFromUnions({ghostsNode, unions, addNodeObjsCopy})
    nodeObjsCopy[ghostsNode].addNodeObj = addNodeObj;
  })

  const focusPrId = yield select(getFocusPrId());
  // Ensure request coming back from server is for the same profile id
  // cause user may click prune tree before request from previous profile id come back
  if( focusPrId === fetchFocusPrId) {
    if(debugWiderCatchForFetchProfiles){
      endTimer = new Date().getTime();
      lastedTime = endTimer - startTimerSaveFetchedProfilesData;
      console.log('Pull and save nodesObjs from redux took: ' + (lastedTime/1000) + ' secs');
      console.count('count of setNodesObjs');
    }
    const fromWhere = 'fetchProfilesSaga - saveFetchedProfilesData';
    yield put(setNodesObjs(nodeObjsCopy, fromWhere));

    if( typeof(firstTreeMatchCountNode) !== 'undefined' ){
      yield put(set_firstTreeMatchCountNode( firstTreeMatchCountNode));
    }

    if( typeof(firstRecordMatchCountNode) !== 'undefined' ){
      yield put(set_firstRecordMatchcCountNode( firstRecordMatchCountNode));
    }

    fetchedProfilesDatas = [];

    if(setAllProfilesIsFetchedArray.length) {
      setAllProfilesIsFetchedArray.forEach((setAllProfilesIsFetched)=>{
        if( typeof(setAllProfilesIsFetched) === 'function' ){
          // console.log('Saga setAllProfilesIsFetched');
          setAllProfilesIsFetched();
        }
      });
      setAllProfilesIsFetchedArray  = [];
    }

    if(fetchProfilesActionCallbackAllowComponentUpdateArray.length) {
      fetchProfilesActionCallbackAllowComponentUpdateArray.forEach((callbackAllowComponentUpdate)=>{
        if( typeof(callbackAllowComponentUpdate) === 'function' ){
          callbackAllowComponentUpdate();
          // console.log('Saga callbackAllowComponentUpdate');
        }
      });
      fetchProfilesActionCallbackAllowComponentUpdateArray  = [];
    }

    if(fetchProfilesActionPostfetchArray.length) {
      fetchProfilesActionPostfetchArray.forEach((fetchProfilesActionPostfetch)=>{
        if( typeof(fetchProfilesActionPostfetch) === 'function' ){
          fetchProfilesActionPostfetch();
          // console.log('Saga fetchProfilesActionPostfetch');
        }
      });
      fetchProfilesActionPostfetchArray  = [];
    }

    if(callRedrawArray.length) {
      callRedrawArray.forEach((callRedraw)=>{
        if( typeof(callRedraw) === 'function' ){
          callRedraw();
          // console.log('Saga fetchProfilesActionPostfetch');
        }
      });
      callRedrawArray  = [];
    }


  } else {
    console.log('Skipping cause focusPrId !== fetchFocusPrId');
  }
  fetchProfilesSagaIsBusy = false;

}

function* notifyProfileAdd({node}) {

  let nodeObjsCopy = null;

  const nodeObjsOrig = yield select(getNodeObjs());

  nodeObjsCopy = cloneDeep(nodeObjsOrig);

  nodeObjsCopy[node].hasMoreAdd = true;
  yield put(setNodesObjs(nodeObjsCopy, 'notifyProfileAdd'));

}

function* updateMatchCounts({node, matchData, tmn, rmn, firstMatchCallback}) {

  let nodeObjsCopy = null;
  const nodeObjsOrig = yield select(getNodeObjs());
  nodeObjsCopy = cloneDeep(nodeObjsOrig);

  // if( nodeObjsCopy[node].sm_vscore !== matchData.sm_vscore ) nodeObjsCopy[node].sm_vscore = matchData.sm_vscore;
  // if( nodeObjsCopy[node].rm_vscore !== matchData.rm_vscore ) nodeObjsCopy[node].rm_vscore = matchData.rm_vscore;
  if( typeof(matchData.tm) !== 'undefined' && nodeObjsCopy[node].tm !== matchData.tm ) nodeObjsCopy[node].tm = matchData.tm;
  if( typeof(matchData.rm) !== 'undefined' && nodeObjsCopy[node].rm !== matchData.rm ) nodeObjsCopy[node].rm = matchData.rm;
  if( typeof(matchData.sm) !== 'undefined' && nodeObjsCopy[node].sm !== matchData.sm ) nodeObjsCopy[node].sm = matchData.sm;

  var _tm = (typeof(nodeObjsCopy[node].tm) !== 'undefined' ? nodeObjsCopy[node].tm : 0);
  var _rm = (typeof(nodeObjsCopy[node].rm) !== 'undefined' ? nodeObjsCopy[node].rm : 0);
  var _sm = (typeof(nodeObjsCopy[node].sm) !== 'undefined' ? nodeObjsCopy[node].sm : 0);

  var match_count = parseInt(_tm, 10) + parseInt(_rm, 10) + parseInt(_sm, 10);

  nodeObjsCopy[node].match_count = match_count;
  yield put(setNodesObjs(nodeObjsCopy, 'updateMatchCounts'));

  if( typeof(tmn) !== 'undefined' || typeof(rmn) !== 'undefined' ){

    if( typeof(tmn) !== 'undefined'  ){
      const firstTreeMatchCountNode = node;
      yield put(set_firstTreeMatchCountNode( firstTreeMatchCountNode, 'updateMatchCounts'));
    }
    if( typeof(rmn) !== 'undefined'  ){
      const firstRecordMatchCountNode = node;
      yield put(set_firstRecordMatchcCountNode( firstRecordMatchCountNode, 'updateMatchCounts'));
    }

    firstMatchCallback();

  }

}


function* updateFullnameArrayWidth({fontFamily}) {

  let nodeObjsCopy = null;
  const nodeObjsOrig = yield select(getNodeObjs());
  nodeObjsCopy = cloneDeep(nodeObjsOrig);

  nodeObjsCopy = adaptWidthFullnameArrrayForCustomFontsDualpedigree({ nodeObjs: nodeObjsCopy, fontFamily});

  yield put(setNodesObjs(nodeObjsCopy, 'updateFullnameArrayWidth'));
}

export function* spawnFetchPrunes(fetchPrunesAction) {

  if(urlGet('cancelPrunes') === "true") return;

  if( debugFetchPrunes ) console.log('<<<< spawnFetchPrunes >>>>');

  const newPrunesObj = fetchPrunesAction.newPrunesObj;
  const target_ids = [];

  if(debugFetchPrunes){
    console.log(`newPrunesObj: `, JSON.stringify(newPrunesObj, null, 2));
    console.log(`requestedFetchPrunesNodeIds: `, JSON.stringify(requestedFetchPrunesNodeIds, null, 2));
  }

  for (let pid in newPrunesObj) {
    if (newPrunesObj.hasOwnProperty(pid)) {
      const nodeId = newPrunesObj[pid];
      if( !requestedFetchPrunesNodeIds.includes(nodeId)){
        target_ids.push(pid);
      } else {
        if(debugFetchPrunes) console.log('Already requested pid: ', pid,' of node: ', nodeId);
      }
      requestedFetchPrunesNodeIds.push(nodeId);
    }
  }

  // for (let pid in newPrunesObj) {
  //   if (newPrunesObj.hasOwnProperty(pid)) {
  //     target_ids.push(pid);
  //   }
  // }

  if(debugFetchPrunes){
    console.log(`target_ids: `, JSON.stringify(target_ids, null, 2));
  }

  clearTimeout(resetRequestedFetchPrunesTimeout);
  resetRequestedFetchPrunesTimeout = setTimeout(() => {
    requestedFetchPrunesNodeIds = [];
  }, timeTillResetRequestedFetchPrunesNodeIds);

  if(target_ids.length < 1) return;

  yield spawn(fetchPrunesSaga, fetchPrunesAction, target_ids);

}

export function* fetchPrunesSaga(fetchPrunesAction, target_ids) {

  let nodeObjsCopy = null;
  let firstNodeWithPrune = undefined;
  let combinedPrunes = [];
  const fetchFocusPrId = yield select(getFocusPrId());
  const newPrunesObj = fetchPrunesAction.newPrunesObj;

  if(typeof(fetchPrunesAction.prefetch) === 'function') fetchPrunesAction.prefetch();
  if(target_ids.length > 0 ){

    const chunks = breakIdsIntoChunks({ids: target_ids, chunkLength: fetchPrunesChunkLength})

    if(debugFetchPrunes) console.log(`chunks: `, JSON.stringify(chunks, null, 2));

    if(typeof(fetchPrunesAction.prefetch) === 'function') fetchPrunesAction.prefetch();

    const callRequestArray = chunks.map((chunk) => {
      const requestURL = `${host}/flash/fetch_prune_counts?treeSessionId=${treeSessionId}&profile=${fetchFocusPrId}&target_ids=${chunk.toString()}&format=json`;
      return call(request, requestURL);
    })

    if(debugFetchPrunes){
      startTimer = new Date().getTime();
    }

    // console.log(' +++++ Delaying 4s for Testing Purposes');
    // yield delay(3000)

    let datas = undefined;
    datas = yield all([...callRequestArray]);

    if(debugFetchPrunes){
      endTimer = new Date().getTime();
      lastedTime = endTimer - startTimer;
      console.log('server batch fetchPrunes took: ' + (lastedTime/1000) + ' secs');
    }

/*

    const requestURL2 = `${host}/flash/fetch_prune_counts?profile=${fetchFocusPrId}&target_ids=${target_ids.toString()}&format=json`;
    const data = yield call(request, requestURL2);

 */
    const nodeObjsOrig = yield select(getNodeObjs());
    nodeObjsCopy = cloneDeep(nodeObjsOrig);

    for (let i = 0; i < datas.length; ++i) {
      combinedPrunes.push(...datas[i].prune_counts);
    };

    combinedPrunes.forEach((obj) => {
      const n = newPrunesObj[obj.pid];
      const pruneCount = obj.p;
      if(typeof(nodeObjsCopy[n]) !== 'undefined'){
        if(typeof(nodeObjsCopy[n].cyclemaster) !== 'undefined'){
          if( typeof(firstNodeWithPrune) === 'undefined' ) firstNodeWithPrune = n;
          const nodeNumbers = getNodeFromNodeObjsWithPid({nodeObjs: nodeObjsCopy, pid: obj.pid, fromWhere: 'fetchPrunesSaga'});
          nodeNumbers.forEach((nodeNumber)=>{
            nodeObjsCopy[nodeNumber].p = (pruneCount === '+' ? '-': pruneCount);
          });
        } else {
          if( typeof(firstNodeWithPrune) === 'undefined' ) firstNodeWithPrune = n;
          nodeObjsCopy[n].p = (pruneCount === '+' ? '-': pruneCount); /* Prune tree disappears when negative.  See canShowPruneTree */
        }
      }
    })

  } else {
    if(debugFetchPrunes) console.log('No prunes were needed from server');
  }

  if( combinedPrunes.length > 0 ){
    const focusPrId = yield select(getFocusPrId());
    // Ensure request coming back from server is for the same profile id
    // cause user may click prune tree before request from previous profile id come back
    if( focusPrId === fetchFocusPrId) {
      const fromWhere = 'fetchPrunesSaga';
      yield put(setNodesObjs(nodeObjsCopy, fromWhere));
      if(typeof(fetchPrunesAction.postfetch) !== 'undefined') fetchPrunesAction.postfetch( { firstNodeWithPrune } );
    } else {
      if(debugFetchPrunes) console.log('focusPrId !== fetchFocusPrId');

    }

  } else {
    if(debugFetchPrunes) console.log('No prunes were saved. target_ids.length: ', target_ids.length);
  }

}

export function* fetchFlipDataSaga(fetchFlipDataAction) {

  if(fetchProfilesSagaIsBusy) {
    // console.log('Delaying fetchFlipData .8 sec cause fetchProfilesSagaIsBusy');
    yield delay(800);
  }

  let nodeObjsOrig = yield select(getNodeObjs());
  let nodeObjsCopy = cloneDeep(nodeObjsOrig);

  const prId = fetchFlipDataAction.pr_id;
  const node = fetchFlipDataAction.node;
  const requestURL = `${host}/profile_flip/flip_data/${prId}?treeSessionId=${treeSessionId}`;
  try {

    /*
     *
     *
     *
      Creating placeholder with n = 'flip-[n]' nodes for immediateFamily clicks
     *
     *
     */
/*

   console.log(`%c fetchFlipDataSaga`, [
     'color: white',
     'background: blue',
     'font-size: 14px',
     'border: 5px solid red',
     'padding: 10px',
     ].join(';'));

   console.log(`nodeObjsCopy[node]: `, JSON.stringify(nodeObjsCopy[node], null, 2));
 */

    if(typeof(nodeObjsCopy[node]) === 'undefined' ){
      yield put(setFlipData(null));
      nodeObjsCopy[node] = {};

      let flipData = undefined;

      if(urlGet('import') === "true"){
        flipData = ( urlGet('import') === "true" ? dataFlip: flipData);
      } else {
        flipData = yield call(request, requestURL);
      }

      // if(urlGet('export') === "true" || urlGet('import') === "true") console.log(`flipData: `, JSON.stringify(flipData, null, 2));

      const nodes = flipData.immediate_family.tree.nodes;
      const nodeObjArr = nodes.filter((n)=>{
        return n.pr_id === prId;
      });
      let nodeObj = nodeObjArr[0];
      nodeObj.prId = prId;
      const mediumUrlSrc = flipData.attrs.mugshot_url_medium;
      const imgObj = (
        typeof(mediumUrlSrc) === 'undefined'
         ?
        { type: 'placeholder', src: `${imageBasePath}no_photo_${nodeObj.g}.gif`}
         :
        { type: 'real', src: mediumUrlSrc})
      nodeObjsCopy[node] = {flipData, ...nodeObj};

      const immediateFamObj = buildImmediateFamilyObj({
        nodes,
        unions: flipData.immediate_family.tree.unions,
        lookUpPrId:{},
        lookUpNodeId:{},
        focusPrId: prId,
        focusGender: nodeObjsCopy[node].g,
        skipTruncate: true,
      })

      nodeObjsCopy[node].immediateFam = immediateFamObj;
      delete flipData.immediate_family;
      nodeObjsCopy[node].n = node;  // must replace nodeObj.n coming from nodeObjArr with fake nodeObj.n `node-${prId}`

      nodeObjsCopy[node].l = nodeObj.l; // Filling in the 'living property' cause we did not pull it from fetchtree.
      nodeObjsCopy[node].a = nodeObj.a; // Filling in the 'living property' cause we did not pull it from fetchtree.
      nodeObjsCopy[node].e = nodeObj.e; // Filling in the 'living property' cause we did not pull it from fetchtree.
      nodeObjsCopy[node].nm = nodeObj.nm;

      nodeObjsCopy[node].ppu = nodeObj.ppu;

      delete nodeObjsCopy[node].focus;
      nodeObjsCopy[node].img = imgObj;


      yield put(setFlipData(flipData));
      const fromWhere = 'fetchFlipDataSaga';
      yield put(setNodesObjs(nodeObjsCopy, fromWhere));

      if(typeof(fetchFlipDataAction.callSetNodeObjPic) !== 'undefined'){
        fetchFlipDataAction.callSetNodeObjPic(nodeObjsCopy[node]);
      }

      if(typeof(fetchFlipDataAction.callback) !== 'undefined') fetchFlipDataAction.callback({node});

    } else {

      /*
       *
       *
       *
       *
       *  Pull from redux nodeObjs
       *
       *
       *
       *
       *

       */

      if(typeof(nodeObjsCopy[node].flipData) !== 'undefined'){

        let flipData = nodeObjsCopy[node].flipData;

        yield put(setFlipData(flipData));

        if(typeof(fetchFlipDataAction.callback) !== 'undefined') fetchFlipDataAction.callback({node});

      } else{

        let flipData = undefined;
        // if(urlGet('import') === "true"){
        //   flipData = ( urlGet('import') === "true" ? dataFlip: flipData);
        // } else {
          yield put(setFlipData(null));
          flipData = yield call(request, requestURL);
          // flipData = dataFlip;

          /*
            We want to pull copy of nodeObj only after flipdata has been fetched from server
            to avoid overwriting image saved from SET_NODEOBJ_PIC
           */

          nodeObjsOrig = yield select(getNodeObjs());
          nodeObjsCopy = cloneDeep(nodeObjsOrig);


        // }

        if(urlGet('export') === "true") console.log(`flipData: `, JSON.stringify(flipData, null, 2));

        const nodes = flipData.immediate_family.tree.nodes;
        // const unions = flipData.immediate_family.tree.unions;

        // console.log(`unions: `, JSON.stringify(unions, null, 2));

        const nodeObjArr = nodes.filter((n)=>{
          return n.pr_id === prId;
        });
        const nodeObj = nodeObjArr[0];
        // console.log(`nodeObj: `, JSON.stringify(nodeObj, null, 2));
        // CHECK
        nodeObjsCopy[node].l = nodeObj.l; // Filling in the 'living property' cause we did not pull it from fetchtree.
        nodeObjsCopy[node].a = nodeObj.a;
        nodeObjsCopy[node].e = nodeObj.e;
        nodeObjsCopy[node].nm = nodeObj.nm;
        nodeObjsCopy[node].ppu = nodeObj.ppu;
        if( nodeObjsCopy[node].img.type === 'placeholder' ) {
          const mediumUrlSrc = flipData.attrs.mugshot_url_medium;
          const imgObj = (
          typeof(mediumUrlSrc) === 'undefined'
           ?
          { type: 'placeholder', src: `${imageBasePath}no_photo_${nodeObjsCopy[node].g}.gif`}
           :
          { type: 'real', src: mediumUrlSrc})
          nodeObjsCopy[node].img = imgObj;
          if(typeof(fetchFlipDataAction.callSetNodeObjPic) !== 'undefined'){
            fetchFlipDataAction.callSetNodeObjPic(nodeObjsCopy[node]);
          }
        }

        const immediateFamObj = buildImmediateFamilyObj({
          nodes,
          unions: flipData.immediate_family.tree.unions,
          lookUpPrId:{},
          lookUpNodeId:{},
          focusPrId: prId,
          focusGender: nodeObjsCopy[node].g,
        })

        nodeObjsCopy[node].immediateFam = immediateFamObj;

        delete flipData.immediate_family;

        nodeObjsCopy[node].flipData = flipData;

        /*

          TEST

          console.log(`flipData: `, JSON.stringify(flipData, null, 2));

          flipData.display.action_add = false;
          flipData.display.action_edit = true;

         */


        // yield delay(3000);
        yield put(setFlipData(flipData));
        const fromWhere = 'fetchFlipDataSaga';
        yield put(setNodesObjs(nodeObjsCopy, fromWhere));

        if(typeof(fetchFlipDataAction.callback) !== 'undefined') fetchFlipDataAction.callback({node});
      }

    }



  } catch (err) {
    console.log(err);
  }

}

export function* unsetFlipDataSaga(unsetFlipDataAction) {

  const flipData = undefined;
  yield put(setFlipData(flipData));

}

export function* unsetNodeObjProperties(unsetNodeObjProperties) {

  const clearNodeObj = (nodeObj) =>{
    nodeObj.nn = undefined;
    nodeObj.updated = false;
    nodeObj.fn = undefined;
    nodeObj.nm = undefined;
    nodeObj.a = undefined;
    nodeObj.e = undefined;
    nodeObj.c = undefined;
    nodeObj.mp = undefined;
    nodeObj.sh = undefined;
    nodeObj.photoBorderColor = undefined;
    nodeObj.dob_c = undefined;
    nodeObj.dod_c = undefined;
    nodeObj.dod_y = undefined;
    nodeObj.dob_y = undefined;
    nodeObj.vsum = undefined;
    nodeObj.g_e = undefined;
    nodeObj.dna = undefined;
    nodeObj.sm_vscore = undefined;
    nodeObj.rm_score = undefined;
    // nodeObj.vsum = undefined;
    nodeObj.tm = undefined;
    nodeObj.rm = undefined;
    nodeObj.sm = undefined;
    nodeObj.dateAlive = undefined;;
    nodeObj.match_count = undefined;
    nodeObj.flipData = undefined;
    nodeObj.img = {
      "type": "placeholder",
      "src": `${imageBasePath}no_photo_${nodeObj.g}.gif`,
      "imageReset": true,
    }
    requestedFetchProfilesNodeIds = requestedFetchProfilesNodeIds.filter(item => item !== nodeObj.n.toString());
    // console.log(`requestedFetchProfilesNodeIds: `, requestedFetchProfilesNodeIds);
    // console.log(`nodeObj: `, JSON.stringify(nodeObj, null, 2));
    return nodeObj;

  }

  const node = unsetNodeObjProperties.node;
  const nodes = unsetNodeObjProperties.nodes;
  const all = unsetNodeObjProperties.all;
  const nodeObjsOrig = yield select(getNodeObjs());
  let nodeObjsCopy = cloneDeep(nodeObjsOrig);
  if(typeof(all) !== 'undefined'){
    console.log(' clearing all ');
    for (let node in nodeObjsCopy) {
      if(nodeObjsCopy[node].nt === 'ghost') continue;
      nodeObjsCopy[node] = clearNodeObj(nodeObjsCopy[node]);
    }
  } else if(typeof(nodes) !== 'undefined'){
    nodes.forEach((node)=>{
      nodeObjsCopy[node] = clearNodeObj(nodeObjsCopy[node]);
    })
  } else if(typeof(node) !== 'undefined'){
    console.log(`node: `, node);
    nodeObjsCopy[node] = clearNodeObj(nodeObjsCopy[node]);
  }

  const fromWhere = 'unsetNodeObjProperties';
  yield put(setNodesObjs(nodeObjsCopy, fromWhere));

}

export function* unsetNodeObjPic(unsetNodeObjPic) {

  const clearNodeObjPic = (nodeObj) =>{

    nodeObj.img = {
      "type": "placeholder",
      "src": `${imageBasePath}no_photo_${nodeObj.g}.gif`,
      "imageReset": true,
    };

    return nodeObj;

  }

  const node = unsetNodeObjPic.node;
  const all = unsetNodeObjPic.all;
  const nodeObjsOrig = yield select(getNodeObjs());
  let nodeObjsCopy = cloneDeep(nodeObjsOrig);
  if(typeof(all) !== 'undefined'){
    for (let node in nodeObjsCopy) {
      nodeObjsCopy[node] = clearNodeObjPic(nodeObjsCopy[node]);
    }
  } else {
    nodeObjsCopy[node] = clearNodeObjPic(nodeObjsCopy[node]);
  }

  const fromWhere = 'unsetNodeObjPic';
  yield put(setNodesObjs(nodeObjsCopy, fromWhere));

}


// let imgLoadedInRangeCount = 0;
// let maxImgLoadedInRangeCount = 10;

function* queueFetchedNodeObjPic({ node, imgObj }) {
  fetchedNodeObjPicsinQueue.push({ node, imgObj });
  yield delay(0);
}

//https://github.com/redux-saga/redux-saga/issues/193
let isReleaseTimerFetchedNodeObjPicsSet = false;
export function* releaseTimerFetchedNodeObjPics({ delayInMilisec }) {
  if( isReleaseTimerFetchedNodeObjPicsSet ) return;
  isReleaseTimerFetchedNodeObjPicsSet = true;
  // console.log('>>>>>> Delay 2sec releaseQueueOfFetchedNodeObjPics >>>>>>');
  yield delay(typeof(delayInMilisec) !== 'undefined' ? delayInMilisec: 2000 );
  if( fetchedNodeObjPicsinQueue.length > 0 ){
    yield fork(releaseQueueOfFetchedNodeObjPics, {});
  } else {
    isReleaseTimerFetchedNodeObjPicsSet = false;
  }
}

export function* checkQueueFetchedNodeObjPic() {
  console.log(`fetchedNodeObjPicsinQueue: `, JSON.stringify(fetchedNodeObjPicsinQueue, null, 2));
  yield delay(0);
}

function* releaseQueueOfFetchedNodeObjPics() {
  if( fetchedNodeObjPicsinQueue.length === 0 ) return;

  const nodeObjsOrig = yield select(getNodeObjs());
  let nodeObjsCopy = cloneDeep(nodeObjsOrig);

  for (let i = 0; i < fetchedNodeObjPicsinQueue.length; ++i) {
    const { node, imgObj } = fetchedNodeObjPicsinQueue[i];
    nodeObjsCopy[node].img = imgObj;
  };

  yield put(setNodesObjs(nodeObjsCopy, 'releaseQueueOfFetchedNodeObjPics'));
  fetchedNodeObjPicsinQueue = [];
  isReleaseTimerFetchedNodeObjPicsSet = false;
}

export function* setNodeObjPic({node, imgObj, delayInMilisec}) {
  yield fork(queueFetchedNodeObjPic, { node, imgObj });
  yield spawn(releaseTimerFetchedNodeObjPics, { delayInMilisec });
}

export function* unsetNodeObjGedcom(obj) {
  const node = obj.node;
  const nodeObjsOrig = yield select(getNodeObjs());
  let nodeObjsCopy = cloneDeep(nodeObjsOrig);
  nodeObjsCopy[node].gc = undefined;
  const fromWhere = 'unsetNodeObjGedcom';
  yield put(setNodesObjs(nodeObjsCopy, fromWhere));
}

export function* undesignateDropTarget( undesignateDropTargetAction ) {  // DEPRECIATED

  const nodeObjsOrig = yield select(getNodeObjs());
  const node = undesignateDropTargetAction.node;

  let nodeObjsCopy = cloneDeep(nodeObjsOrig);

  delete nodeObjsCopy[node].dropTarget;

  const fromWhere = 'undesignateDropTarget';
  yield put(setNodesObjs(nodeObjsCopy, fromWhere));

}

export function* postInvite(postInviteAction) {

  const email = postInviteAction.email;
  const prId = postInviteAction.prId;
  const node = postInviteAction.node;
  const callbackWhen = postInviteAction.callbackWhen;
  const callback = postInviteAction.callback;
  const requestURL = `${host}/profile_actions/invite_tree/${prId}?treeSessionId=${treeSessionId}`;

  // https://www.geni.com/profile_actions/add_email/<target_profile_id>?email=<CGI-encoded email address>
  //
  // const body = JSON.stringify({email});
  // // const body = {email};
  // const headers = {
  //   'Content-Type': 'application/json',
  //   'X-Requested-With' : 'XMLHttpRequest'
  // };

  const requestPostOptions = buildRequestJsonPostOptions({email,})

  if(isDevelopment){

    if( callbackWhen === 'before') {
      callback({});
      yield delay(timeDelayForInviteIsSent);
    }

    const nodeObjsOrig = yield select(getNodeObjs());
    const nodeObjsCopy = cloneDeep(nodeObjsOrig);
    nodeObjsCopy[node].g_e = undefined;
    const fromWhere = 'postInvite';
    yield put(setNodesObjs(nodeObjsCopy, fromWhere));

    if( callbackWhen === 'after') callback();

    return;
  }

  console.log(JSON.stringify(requestPostOptions, null, 2));


  try {

    const data = yield call(request, requestURL, requestPostOptions);
    // const data = {};
    // data.success = false;
    // data.success = true;

    if(data.success) {

      console.log('data.success');

      if( callbackWhen === 'before') {
        callback({});
        yield delay(timeDelayForInviteIsSent);
      }

      const nodeObjsOrig = yield select(getNodeObjs());
      const nodeObjsCopy = cloneDeep(nodeObjsOrig);
      nodeObjsCopy[node].g_e = undefined;
      console.log('node: ' + node + ' has g_e ' + nodeObjsCopy[node].g_e);
      const fromWhere = 'postInvite';
      yield put(setNodesObjs(nodeObjsCopy, fromWhere));

      if( callbackWhen === 'after') callback();

    } else {

      console.log('data not success');

      const serverMessage = 'Something went wrong!';
      callback({serverMessage});
    }


  } catch (err) {

    const serverMessage = 'Localhost Dev server success';
    callback({serverMessage});
    // console.log(err);
  }


}


export function* fetchPrefencesSaga({callbackAfterPreferenceFetch}) {

  const guide_page_redux = yield select(getGuide_page());
  // console.log(`pulling guide_page_redux: `, guide_page_redux);
  const requestURL = `${host}/account_settings/preferences?treeSessionId=${treeSessionId}`;

  try {

    const data = yield call(request, requestURL);

    const { preferences } = data;

    const { date_format, prune_ancestors_num, prune_descendants_num, show_floaters_help, show_middle_names, hide_hot_match_prompt, hide_public_warning, hide_record_match_prompt } = preferences;
    let { show_guide, guide_page, show_ancestors } = preferences;

    // console.log(`{ prune_ancestors_num, prune_descendants_num}: `, JSON.stringify({ prune_ancestors_num, prune_descendants_num}, null, 2));
    if( isDevelopment || isSeinfeld ){

      // console.log(styles.maleCustomColor);

    } else {
      // console.log(`preferences: `, JSON.stringify({ show_guide, guide_page, show_ancestors }, null, 2));
    }

    show_guide = ( show_guide === 1 ? true: false);
    show_ancestors = ( show_ancestors === 1 ? true: false);

    guide_page = ( typeof( guide_page ) !== 'undefined' && guide_page > 0 ? guide_page: 1);
    guide_page = ( typeof( guide_page_redux ) !== 'undefined' ? guide_page_redux: guide_page);

    // if( isDevelopment || isSeinfeld ){
    //   show_guide = false;
    //   console.log('Development makes show_guide true.');
    //   guide_page = 1;
    //   console.log('Development makes guide_page 1.');
    // }

    guide_page = parseInt(urlGet('guide_page'), 10) || guide_page;
    show_guide = urlGet('show_guide') || show_guide;
    show_guide = (  show_guide === '1' ||  show_guide === 1 || show_guide === 'true' || show_guide === true ? true: false);

    /*

        Example:
        https://stage.geni.com/family-tree/index/324002769390004386?show_guide=true&guide_page=5
        https://stage.geni.com/family-tree/index/<prId>?show_guide=true&guide_page=5


     */

    // guide_page--

    // console.log(`Storing guide_page as: `, guide_page);
    // console.log(`Storing show_guide as: `, show_guide);
    // console.log(`Storing show_ancestors as: `, show_ancestors);

    const isPedigree = yield select(getIsPedigree());
    const isDualPedigree = yield select(getIsDualPedigree());
    let preferencesObj = {
      date_format,
      isPedigree,
      isDualPedigree,
      ancestors: prune_ancestors_num,
      descendants: prune_descendants_num,
      show_guide,
      guide_page,
      show_ancestors,
      show_floaters_help,
      show_middle_names,
      hide_hot_match_prompt,
      hide_public_warning,
      hide_record_match_prompt,
    }

    yield put(setPreferences(preferencesObj));

    if(typeof(callbackAfterPreferenceFetch) !== 'undefined' ) callbackAfterPreferenceFetch({ show_guide, guide_page });

  } catch (err) {
    console.log(err);
  }

}

export function* make_inflight_sagas_stop() { // FOR TESTING PURPOSES

  // https://github.com/redux-saga/redux-saga/blob/master/docs/advanced/TaskCancellation.md
  // https://stackoverflow.com/questions/37689562/cancel-a-saga-when-an-action-is-dispatched-with-redux-saga

  console.log('Stopping Inflight Sagas....');
  // stop_inflight_sagas = true;
  yield delay(100);

}

export function* postReduxPreferences({ guide_page, callback }) {
  // console.log(`saving redux guide_page: `, guide_page);
  yield put(setPreferences({guide_page, }));
}

export function* getUnionIdForFanChart({
  callFetchTree,
  focusPrId,
 }){

    let unionId;
    const baseUrl = `${host}/poster/`;

    let requestURL = `${baseUrl}list?treeSessionId=${treeSessionId}&profile_id=${focusPrId}`;
    if( typeof(focusPrId) !== 'undefined' ) requestURL += ``;

    const listData = yield call(request, requestURL);

    // console.log(`listData: `, JSON.stringify(listData, null, 2));

    const partnerUnions = listData.partnerUnions;
    const parentUnions = listData.parentUnions;

    let firstPartnerUnionId = undefined;
    let firstParentUnionId = undefined;

    if( typeof(partnerUnions[0]) !== 'undefined' ){
    firstPartnerUnionId = partnerUnions[0].unionId;
    }

    if( typeof(parentUnions[0]) !== 'undefined' ){
    firstParentUnionId = parentUnions[0].unionId;
    }

    unionId = ( typeof(firstPartnerUnionId) !== 'undefined' ? firstPartnerUnionId : firstParentUnionId );

   console.log(`%c getUnionIdForFanChart : ${ unionId }`, [
     'color: white',
     'background: orange',
     'font-size: 14px',
     'border: 5px solid red',
     'padding: 10px',
     ].join(';'));

    callFetchTree({unionId});

}

export function* postPoster({
  action,
  unionId,
  tpId,
  prId,
  focusPrId,
  posterData,
  node,
  custom,
  frameStyle,
  titleBorder,
  fontFamily,
  backgroundTextureFileName,
  changedDualPedigreeObj,
  searchterm,
  titleName,
  profileName,
  callFetchTree,
  callSetBackgroundTextureDualPedigree,
  callReloadCanvasTree,
  includeDate,
  whichChildrenNode,
 }){

  // console.log('postPoster: ',  action);

  const baseUrl = `${host}/poster/`;
  let results = undefined;
  let requestURL = undefined;
  let requestPostOptions = undefined;
  let posters = undefined;
  let dualPedigreeObj = {};

  switch(action) {

    case 'test':

        yield put(setPreferences({ foo: true }));
        // console.log(`action: `, action);

        break;

    case 'dev':

        yield put(setPreferences({ isDualPedigree: true }));
        callFetchTree();

        break;

    case 'save':

          // console.log(`save/posterData: `, JSON.stringify(posterData, null, 2));

          requestPostOptions = buildRequestJsonPostOptions({data: posterData,})
          requestURL = `${host}/poster/save/${tpId}?treeSessionId=${treeSessionId}`;

          // console.log(`%c Save: ${tpId}`, [
          // 'color: white',
          // 'background: orange',
          // 'font-size: 14px',
          // 'border: 5px solid red',
          // 'padding: 10px',
          // ].join(';'));

          /*const saveData =*/ yield call(request, requestURL, requestPostOptions);

          // console.log(`saveData: `, JSON.stringify(saveData, null, 2));

        break;


    case 'saveChangedDualPedigreeObjPref':

          const oldDualPedigreeObj = yield select(getDualPedigreeObj());
          const newDualPedigreeObj = {
            ...oldDualPedigreeObj,
            ...changedDualPedigreeObj,
          }

          yield put(setPreferences({
            dualPedigreeObj: newDualPedigreeObj
          }));

          if( typeof(callSetBackgroundTextureDualPedigree) !== 'undefined' ) callSetBackgroundTextureDualPedigree();

        break;

    case 'load':

          requestURL = `${baseUrl}load/${tpId}?treeSessionId=${treeSessionId}`;

          results = yield call(request, requestURL);

          // console.log(`%c Loading: ${tpId}`, [
          // 'color: white',
          // 'background: green',
          // 'font-size: 14px',
          // 'border: 5px solid red',
          // 'padding: 10px',
          // ].join(';'));

          // console.log(`tpId: `, JSON.stringify(results, null, 2));

        break;

    case 'search':

          // requestURL = `${baseUrl}load/${tpId}?treeSessionId=${treeSessionId}`;


          requestURL = searchterm;
          // console.log(`requestURL: `, requestURL);

          // results = yield call(request, requestURL);

          // console.log(`results: `, JSON.stringify(results, null, 2));

        break;

    case 'create':

          requestPostOptions = buildRequestJsonPostOptions({});
          requestURL = `${baseUrl}create?treeSessionId=${treeSessionId}`;

          results = yield call(request, requestURL, requestPostOptions);
          const createdDualPedigreePosterId = results.tpId;

          // window.alert('createdTpId: ' + createdDualPedigreePosterId);

          posterData = {
            tpId: createdDualPedigreePosterId,
            unionId,
            title: `Poster`
          }
          // console.count('create tpId: ', createdDualPedigreePosterId);

          // console.log(`%c Create: ${createdDualPedigreePosterId}`, [
          // 'color: white',
          // 'background: darkgreen',
          // 'font-size: 14px',
          // 'border: 5px solid red',
          // 'padding: 10px',
          // ].join(';'));

          yield call( postPoster, {  action: 'save', tpId: createdDualPedigreePosterId, posterData} );

        break;

    case 'delete':

        // http://192.168.111.62:5000/poster/delete/284
        // console.log('saga delete');

        let deleteThisTpId = undefined;

        if( typeof(tpId) === 'undefined' ){
          dualPedigreeObj = yield select(getDualPedigreeObj());
          posters = dualPedigreeObj.posters;

          // console.log(`posters: `, JSON.stringify(posters, null, 2));

          const posterIdsArray = posters.map((obj)=>{
            return obj.tpId;
          })

          // console.log('deleted: ', posterIdsArray);
          deleteThisTpId  = posterIdsArray[posterIdsArray.length-1];

          requestURL = `${baseUrl}delete/${deleteThisTpId}?treeSessionId=${treeSessionId}`;
        } else {

          deleteThisTpId = tpId;
          requestURL = `${baseUrl}delete/${tpId}?treeSessionId=${treeSessionId}`;
        }

        // console.log(`requestURL: `, requestURL);

        // console.log(`%c Deleting: ${deleteThisTpId}`, [
        // 'color: white',
        // 'background: red',
        // 'font-size: 14px',
        // 'border: 5px solid red',
        // 'padding: 10px',
        // ].join(';'));

        requestPostOptions = buildRequestJsonPostOptions({});
        yield call(request, requestURL, requestPostOptions);

        break;

    case 'fetch':

          requestURL = `${baseUrl}list?treeSessionId=${treeSessionId}&profile_id=${focusPrId}`;
          if( typeof(focusPrId) !== 'undefined' ) requestURL += ``;

          results = yield call(request, requestURL);

        break;

    case 'fetchfocusPrId':

          dualPedigreeObj = yield select(getDualPedigreeObj());

          // console.log(`dualPedigreeObj: `, JSON.stringify(dualPedigreeObj, null, 2));

          if(!dualPedigreeObj.active) {
            const inactiveTpId = dualPedigreeObj.tpId
            // const inactiveUnionId = dualPedigreeObj.unionId
            yield call(postPoster, {action: 'delete', tpId: inactiveTpId});
          } else {
            // window.alert('this is active poster')
          }

          results = yield call(postPoster, {action: 'load', tpId});

          let onePosterData = results.data;
          focusPrId = onePosterData.focusPrId;

          callReloadCanvasTree(focusPrId);

        break;

    case 'reloadPoster':

          results = yield call(postPoster, {action: 'load', tpId});

          onePosterData = results.data;
          focusPrId = onePosterData.focusPrId;

          callReloadCanvasTree(focusPrId);

        break;

    case 'saveDefaultCentering':

          let nodeObjsOrig = yield select(getNodeObjs());
          let nodeObjsCopy = cloneDeep(nodeObjsOrig);

          nodeObjsCopy[node].dualPedigreeCustom =  custom;
          yield put(setNodesObjs(nodeObjsCopy, 'storeCustomRecenteringDualPedigree'));

        break;

    case 'includeDate':
    case 'whichChildrenNode':
    case 'saveProfileName':
    case 'saveTitleNameForUnion':
    case 'saveCustomDataForOneNode':
    case 'saveCustomDataFrameType':
    case 'saveBackgroundTexture':
    case 'chooseTitleBorder':
    case 'chooseFontFamily':

          nodeObjsOrig = yield select(getNodeObjs());
          nodeObjsCopy = cloneDeep(nodeObjsOrig);

          if( action === 'saveCustomDataForOneNode'){

            if( typeof(nodeObjsCopy[node].dualPedigreeCustom) !== 'undefined' ){
              nodeObjsCopy[node].dualPedigreeCustom = {...nodeObjsCopy[node].dualPedigreeCustom, ...custom};
            } else {
              nodeObjsCopy[node].dualPedigreeCustom =  custom;
            }

            yield put(setNodesObjs(nodeObjsCopy, 'storeCustomRecenteringDualPedigree'));

          }

          if( action === 'saveProfileName' && profileName !==  'reset'){

            if( typeof(nodeObjsCopy[node].dualPedigreeCustom) !== 'undefined' ){
              nodeObjsCopy[node].dualPedigreeCustom = {...nodeObjsCopy[node].dualPedigreeCustom, profileName};
            } else {
              nodeObjsCopy[node].dualPedigreeCustom = {profileName};
            }
            yield put(setNodesObjs(nodeObjsCopy, 'saveProfileName'));

          } else if (action === 'saveProfileName' && profileName ===  'reset') {

            if( typeof(nodeObjsCopy[node].dualPedigreeCustom) !== 'undefined' ){
              nodeObjsCopy[node].dualPedigreeCustom = {...nodeObjsCopy[node].dualPedigreeCustom, profileName: undefined};
            } else {
              nodeObjsCopy[node].dualPedigreeCustom = {profileName: undefined};
            }

            yield put(setNodesObjs(nodeObjsCopy, 'saveProfileName'));
          }

          tpId = yield select(getDualPedigreePosterId());
          dualPedigreeObj = yield select(getDualPedigreeObj());

          let customObjs = {};
          for( let nodeCopy in nodeObjsCopy){
            if( typeof(nodeObjsCopy[nodeCopy].dualPedigreeCustom) !== 'undefined'
            ){
              const prId = nodeObjsCopy[nodeCopy].prId;
              customObjs[prId] = nodeObjsCopy[nodeCopy].dualPedigreeCustom;
            }
          }

          if( !dualPedigreeLaunchOnDev ) results = yield call(postPoster, {action: 'load', tpId});
          posterData = (!dualPedigreeLaunchOnDev ? results.data: {});

          posterData = {...posterData, ...{
            active: true,
            tpId: tpId,
            unionId: dualPedigreeObj.unionId,
            customObjs,
            titleBorder: ( action === 'chooseTitleBorder' ? titleBorder: dualPedigreeObj.titleBorder),
            fontFamily: ( action === 'chooseFontFamily' ? fontFamily: dualPedigreeObj.fontFamily),
            backgroundTextureFileName: ( action === 'saveBackgroundTexture' ? backgroundTextureFileName: dualPedigreeObj.backgroundTextureFileName),
            frameStyle: ( action === 'saveCustomDataFrameType' ? frameStyle: dualPedigreeObj.frameStyle),
            titleName: encodeIfNeeded( action === 'saveTitleNameForUnion' ? titleName: dualPedigreeObj.titleName),
            includeDate: ( action === 'includeDate' ? includeDate: dualPedigreeObj.includeDate),
            whichChildrenNode: ( action === 'whichChildrenNode' ? whichChildrenNode: dualPedigreeObj.whichChildrenNode),
          }};

          if( dualPedigreeLaunchOnDev ){

            // console.log(`posterData: `, JSON.stringify(posterData, null, 2));

          } else {
            // console.log(`posterData: `, JSON.stringify(posterData, null, 2));
            posterData.coupleName  = undefined;
            yield call( postPoster, {  action: 'save', tpId, posterData} );

            const listData = yield call(postPoster, {action: 'fetch', focusPrId: dualPedigreeObj.focusPrId});
            posters = listData.posters;
          }

          changedDualPedigreeObj = {
            customObjs,
            posters,
            active:  true,
            titleBorder: ( action === 'chooseTitleBorder' ? titleBorder: dualPedigreeObj.titleBorder),
            fontFamily: ( action === 'chooseFontFamily' ? fontFamily: dualPedigreeObj.fontFamily),
            backgroundTextureFileName: ( action === 'saveBackgroundTexture' ? backgroundTextureFileName: dualPedigreeObj.backgroundTextureFileName),
            frameStyle: ( action === 'saveCustomDataFrameType' ? frameStyle: dualPedigreeObj.frameStyle),
            titleName: ( action === 'saveTitleNameForUnion' ? titleName: dualPedigreeObj.titleName),
            includeDate: ( action === 'includeDate' ? includeDate: dualPedigreeObj.includeDate),
            whichChildrenNode: ( action === 'whichChildrenNode' ? whichChildrenNode: dualPedigreeObj.whichChildrenNode),
          }

          yield call( postPoster, {  action: 'saveChangedDualPedigreeObjPref', changedDualPedigreeObj, callSetBackgroundTextureDualPedigree } );

          // if(typeof(callUpdateFullnameArrayWidth) !== 'undefined') callUpdateFullnameArrayWidth();

          if(action === 'chooseFontFamily') yield call(updateFullnameArrayWidth, {fontFamily});
          if(typeof(callFetchTree) !== 'undefined') callFetchTree();

        break;

    case 'redrawCanvasTree':
    case 'start':

          const listData = yield call(postPoster, {action: 'fetch', focusPrId});

          // console.log(`listData: `, JSON.stringify(listData, null, 2));

          // const postersTpIds = listData.posters.map((obj)=>obj.tpId);
          // const postersUnionIds = listData.posters.map((obj)=>obj.unionId);

          // console.log(`postersTpIds: `, JSON.stringify(postersTpIds, null, 2));
          // console.log(`postersUnionIds: `, JSON.stringify(postersUnionIds, null, 2));

          posters = listData.posters;
          const limit = listData.limit;

          yield put(setPreferences({ isDualPedigree: true }));

          const partnerUnions = listData.partnerUnions;
          const parentUnions = listData.parentUnions;

          let chosenDualPedigreePosterCoupleName = '';
          const unionIdsForPartnerUnions = partnerUnions.map((obj)=>{
            if( action === 'redrawCanvasTree' && unionId === obj.unionId) chosenDualPedigreePosterCoupleName = obj.coupleName;
            return obj.unionId;
          })

          const unionIdsForParentUnions = parentUnions.map((obj)=>{
            if( action === 'redrawCanvasTree' && unionId === obj.unionId) chosenDualPedigreePosterCoupleName = obj.coupleName;
            return obj.unionId;
          })

          let firstPartnerUnionId = undefined;
          let firstPartnerCoupleName = undefined;

          let firstParentUnionId = undefined;
          let firstParentCoupleName = undefined;

          if( typeof(partnerUnions[0]) !== 'undefined' ){
            firstPartnerUnionId = partnerUnions[0].unionId;
            firstPartnerCoupleName = partnerUnions[0].coupleName;
          }


          if( typeof(parentUnions[0]) !== 'undefined' ){
            firstParentUnionId = parentUnions[0].unionId;
            firstParentCoupleName = parentUnions[0].coupleName;
          }

          let unionIds = [];
          unionIds.push(...unionIdsForPartnerUnions);
          unionIds.push(...unionIdsForParentUnions);

          let hasAlreadyCreatedPoster = false;
          let lastHasAlreadyCreatedPosterTpId = undefined;

          // let inactivePosters = [];

          posters.forEach((poster) =>{
            if(unionIds.includes(poster.unionId)){
              hasAlreadyCreatedPoster = true;
              lastHasAlreadyCreatedPosterTpId = poster.tpId;
            };
          });

          let posterMaxLimitReached = false;

                // console.log(`%climit ${limit}: `, [
                // 'color: white',
                // 'background: blue',
                // 'font-size: 14px',
                // 'border: 5px solid red',
                // 'padding: 10px',
                // ].join(';'));


                // console.log(`%chasAlreadyCreatedPoster ${hasAlreadyCreatedPoster}: `, [
                // 'color: white',
                // 'background: blue',
                // 'font-size: 14px',
                // 'border: 5px solid red',
                // 'padding: 10px',
                // ].join(';'));

          if(posters.length === limit && !hasAlreadyCreatedPoster){
            posterMaxLimitReached = true;

              // console.log(`%c posterMaxLimitReached: true`, [
              // 'color: white',
              // 'background: red',
              // 'font-size: 14px',
              // 'border: 5px solid red',
              // 'padding: 10px',
              // ].join(';'));

          } else {

              // console.log(`%c posterMaxLimitReached: false`, [
              // 'color: white',
              // 'background: green',
              // 'font-size: 14px',
              // 'border: 5px solid red',
              // 'padding: 10px',
              // ].join(';'));

          };








          if( action === 'redrawCanvasTree' ) {

            let chosenDualPedigreePosterId = undefined;
            posters.forEach((poster) =>{
              if( poster.unionId === unionId ) chosenDualPedigreePosterId = poster.tpId;
            });

            const isNewPoster = typeof(chosenDualPedigreePosterId) === 'undefined';

            let isActivePoster = undefined;

            if( isNewPoster ){

              /*

                Create new poster

               */

              results = yield call( postPoster, { action: 'create', unionId } );
              chosenDualPedigreePosterId = results.tpId;

              isActivePoster = false;

              posterData = {
                title: encodeIfNeeded(chosenDualPedigreePosterCoupleName),
                // title: chosenDualPedigreePosterCoupleName,
                tpId: chosenDualPedigreePosterId,
                unionId: unionId,
                active: isActivePoster,
                focusPrId,
                customObjs: {},
                titleBorder: defaultDualPedigreeTitleBorder,
                fontFamily: defaultDualPedigreeFontFamily,
                backgroundTextureFileName: defaultBackgroundTextureFileName,
                frameStyle: defaultDualPedigreeFrameStyle,
                includeDate:  true,
                whichChildrenNode: 0,
              }

              yield call( postPoster, {  action: 'save', tpId: chosenDualPedigreePosterId, posterData} );

            } else {

              results = yield call(postPoster, {action: 'load', tpId: chosenDualPedigreePosterId});
              const chosenDualPedigreeData = results.data;
              isActivePoster = chosenDualPedigreeData.active;

            }

            dualPedigreeObj = { tpId: chosenDualPedigreePosterId }
            dualPedigreeObj = {...dualPedigreeObj, active: isActivePoster};

          } else if(hasAlreadyCreatedPoster) {

            // console.log('FOUND EXISTING POSTER');

            /*
                FOUND EXISTING POSTER
             */

            const results = yield call(postPoster, {action: 'load', tpId: lastHasAlreadyCreatedPosterTpId});

            const hasPosterDualPedigreeData = results.data;
            dualPedigreeObj = { tpId: lastHasAlreadyCreatedPosterTpId, active: hasPosterDualPedigreeData.active}
            unionId = hasPosterDualPedigreeData.unionId;

          }

          else {

            // console.log('FIRST TIME CREATING A POSTER');

            /*
                FIRST TIME CREATING A POSTER
             */

             let firstCreatedDualPedigreePosterId = undefined;

             unionId = ( typeof(firstPartnerUnionId) !== 'undefined' ? firstPartnerUnionId : firstParentUnionId );
             if( !posterMaxLimitReached ){

                results = yield call( postPoster, { action: 'create', unionId} );
                firstCreatedDualPedigreePosterId = results.tpId;

                posterData = {
                  title: encodeIfNeeded(( typeof(firstPartnerUnionId) !== 'undefined' ? firstPartnerCoupleName : firstParentCoupleName )),
                  // title: ( typeof(firstPartnerUnionId) !== 'undefined' ? firstPartnerCoupleName : firstParentCoupleName ),
                  tpId: firstCreatedDualPedigreePosterId,
                  active: false,
                  unionId,
                  coupleName: encodeIfNeeded(firstPartnerCoupleName),
                  // coupleName: firstPartnerCoupleName,
                  focusPrId,
                  customObjs: {},
                  titleBorder: defaultDualPedigreeTitleBorder,
                  fontFamily: defaultDualPedigreeFontFamily,
                  backgroundTextureFileName: defaultBackgroundTextureFileName,
                  frameStyle: defaultDualPedigreeFrameStyle,
                  includeDate: true,
                  whichChildrenNode: 0,
                }

                yield call( postPoster, {  action: 'save', tpId: firstCreatedDualPedigreePosterId, posterData} );

             }  else {
              console.log('-- NO NEW POSTER CREATED --');
             }

            dualPedigreeObj = { tpId: ( posterMaxLimitReached ? -1: firstCreatedDualPedigreePosterId), active: false, }

          }

          if( urlGet('useUnionId') ){
            // console.log('THERE IS useUnionId', urlGet('useUnionId'));
            // console.log(`typeof(urlGet('useUnionId')): `, typeof(urlGet('useUnionId')));
            callFetchTree({unionId: urlGet('useUnionId')});
            return;
          }

          let titleDualPedTree = ( typeof(firstPartnerUnionId) !== 'undefined' ? firstPartnerCoupleName : firstParentCoupleName );

          dualPedigreeObj = { ...dualPedigreeObj,
            focusPrId: listData.profile_id,
            limit,
            posterMaxLimitReached,
            unionId,
            unions: {
              partners: listData.partnerUnions,
              parents:  listData.parentUnions,
            },
            includeDate: true,
            posters,
            titleBorder: defaultDualPedigreeTitleBorder,
            frameStyle: defaultDualPedigreeFrameStyle,
            fontFamily: defaultDualPedigreeFontFamily,
            backgroundTextureFileName: defaultBackgroundTextureFileName,
            whichChildrenNode: 0,
            title: titleDualPedTree
            // title: ( typeof(firstPartnerUnionId) !== 'undefined' ? firstPartnerCoupleName : firstParentCoupleName )
          }

          // console.log(`dualPedigreeObj: `, JSON.stringify(dualPedigreeObj, null, 2));

          yield put(setPreferences({ dualPedigreeObj }));

          if(typeof(callFetchTree) !== 'undefined') callFetchTree({unionId});

        break;

    default:

        break;

  }

  if (typeof( results ) !== 'undefined') return results;

}

export function* postPreferences({ ancestors,  descendants, hide_public_warning, show_guide, guide_page, show_ancestors, hide_hot_match_prompt, hide_record_match_prompt, skipReloadCanvasTree, styles, callback, }) {

   console.log(`%c postPreferences`, [
     'color: white',
     'background: red',
     'font-size: 14px',
     'border: 5px solid red',
     'padding: 10px',
     ].join(';'));

  const prune_ancestors_num = ancestors;
  const prune_descendants_num = descendants;

  // if( typeof(styles) !== 'undefined' ) console.log(`styles: `, styles);

  const preferences = {
    prune_ancestors_num,
    prune_descendants_num,
    hide_public_warning,
    hide_hot_match_prompt,
    hide_record_match_prompt,
    show_guide,
    guide_page,
    show_ancestors,
    styles,
  };
console.log(`preferences: `, JSON.stringify(preferences, null, 2));
  let data = undefined;
  if( !isDevelopment ){
    const requestPostOptions = buildRequestJsonPostOptions({preferences,})
    // console.log(`requestPostOptions: `, JSON.stringify(requestPostOptions, null, 2));
    const requestURL = `${host}/account_settings/preferences?treeSessionId=${treeSessionId}`;
    data = yield call(request, requestURL, requestPostOptions);
  } else {
  }

  show_ancestors = ( show_ancestors === true || show_ancestors === 1 ? true: false);
  yield put(setPreferences({guide_page, show_ancestors}));

  if( typeof(data) !== 'undefined' && data.success) {

    const focusPrId = yield select(getFocusPrId());
    const chart_type = yield select(getChartType());

    const param = {};if (typeof skipReloadCanvasTree === 'undefined') {

    if (chart_type === 'fan') {
      setTimeout(() => {
        window.callRefocusFanChart({prId: focusPrId});
      }, 1000);
    } else {
      window.callReloadCanvasTree(focusPrId, param);
    }
  }
    if(typeof(callback) !== 'undefined' ) callback();

  } else {

    console.log('Data not success.  On Dev?');

    const serverMessage = 'Something went wrong!';
    console.log(serverMessage);

  }

}


/*

var profile_id = $('photo_uploader_profile_id').value;
  $('photo_uploader_form').action = "/photo_upload/upload/" + profile_id + "?tag_profile=true";
  $('photo_uploader_return_path').value = "/photo/complete_upload/" + profile_id;
  $("profile_photo_spinner_" + profile_id).show();
  $S('photo_uploader_form');
  $('upload_form_title').update('Upload an image of ' + profile_name)
  $('photo_uploader_profile_id').value= profile_id;
  $('photo_uploader_file').value = "";
  $('photo_uploader_form').target='photo_upload_frame_'+profile_id;

 */

export function* uploadPhoto({ node, title, file, prId, uploadPhotoCallback }) {

  var formData = new FormData();
  formData.append("title", title);
  formData.append("file", file);

  const requestURL = `${host}/api/profile-g${prId}/add-photo`;

  const data = yield call(request, requestURL, { body: formData, method: 'POST' });
  console.log(`data: `, JSON.stringify(data, null, 2));
  // const imgSrc = data.sizes.medium;

  // const nodeObjsOrig = yield select(getNodeObjs());
  // let nodeObjsCopy = cloneDeep(nodeObjsOrig);

  // nodeObjsCopy[node].img = imgSrc;

  // yield put(setNodesObjs(nodeObjsCopy, 'uploadPhoto'));

  uploadPhotoCallback();

}

export function* uploadDocument({ title, file, prId }) {

  var formData = new FormData();
  formData.append("title", title);
  formData.append("file", file);

  const requestURL = `${host}/api/profile-g${prId}/add-document`;

  const data = yield call(request, requestURL, { body: formData, method: 'POST' });


  if(data.success) {

  } else {
    console.log('data not success');
    const serverMessage = 'Something went wrong!';
    console.log(serverMessage);
  }

}

export function* postPreferencesChartType({ chart_type, callback }) {

  // const isPedigree = ( chart_type === 'horizontal' ? true: false);
  // console.log(`chart_type: `, chart_type, ` isPedigree: `, isPedigree);
  // yield put(setPreferences({isPedigree}));

  const preferences = {chart_type};


  const requestPostOptions = buildRequestJsonPostOptions({preferences,})

  // console.log(`requestPostOptions: `, JSON.stringify(requestPostOptions, null, 2));

  const requestURL = `${host}/account_settings/preferences?treeSessionId=${treeSessionId}`;
  // console.log('requestURL: ', requestURL);
  // yield delay(2000);
  const data = yield call(request, requestURL, requestPostOptions);
  // const data = undefined;

  // console.log(JSON.stringify(data, null, 2));

  if(data.success) {


    // yield delay(2000);
    // const focusPrId = yield select(getFocusPrId());
    // const param = {};
    // window.callReloadCanvasTree(focusPrId, param);

    window.location.reload();

  } else {

    console.log('data not success');

    const serverMessage = 'Something went wrong!';
    console.log(serverMessage);

  }

}

export function* postChosenUnionId({ chosenUnionId, childPrId }) {

  const requestPostOptions = buildRequestJsonPostOptions({chosen_union_id: chosenUnionId})

  // console.log(`requestPostOptions: `, JSON.stringify(requestPostOptions, null, 2));

  const requestURL = `${host}/profile/choose_parents_lb/${childPrId}?treeSessionId=${treeSessionId}`;
  // console.log('requestURL: ', requestURL);
  // yield delay(2000);
  const data = yield call(request, requestURL, requestPostOptions);
  // const data = undefined;

  // console.log(JSON.stringify(data, null, 2));
// console.log(`data: `, data);
  if(data.success) {


    // yield delay(2000);
    // const focusPrId = yield select(getFocusPrId());
    // const param = {};
    // window.callReloadCanvasTree(focusPrId, param);

    window.location.reload();

  } else {

    console.log('data not success');

    const serverMessage = 'Something went wrong!';
    console.log(serverMessage);

  }

}

export function* fetchFloatersSaga({callbackWhenEverFloatersExist, callbackWhenEverFloatersDontExist}) {

  let floaters = [];
  const requestURL = `${host}/family-tree/fetch_floaters?treeSessionId=${treeSessionId}`;

  try {

    floaters = yield call(request, requestURL);

    /*

        floaters = [
          {
              "pr_id": "79533",
              "nm": "Roone Pinkney ARLEDGE, Sr.",
              "ln": "Arledge",
              "fn": "Roone",
              "mn": "Pinkney",
              "sfx": "Sr.",
              "g": "m",
              "dob_y": 1990,
              "dob_c": true,
              "t": "http://192.168.0.39:5000/media/p1/fb/8b/d5/a5/e2baf/65f0a3b1-26ec-4f9a-9061-2af4f58c8831_t2.jpg",
              "e": true,
              "npu": 0
          }
        ];
     */

    if(floaters.length > 0){
      callbackWhenEverFloatersExist();
    }  else {
      callbackWhenEverFloatersDontExist();
    }

  } catch (err) {
    console.log(err);
  }

  yield put(setFloaters({floaters}));


}

export function* removeFloaterSaga({prId, showFloaterPanel, redraw}) {

  let floaters = yield select(getFloaters());

  // floaters = removeFromArray(floaters, 'pr_id', prId);
  // fetchingFloaters = true;
  const requestPostOptions = buildRequestJsonPostOptions({id:prId})

  const requestURL = `${host}/family-tree/remove_floater?treeSessionId=${treeSessionId}`;

  floaters = yield call(request, requestURL, requestPostOptions);
  if(floaters.length === 0){
    showFloaterPanel(false);
  }

  yield put(setFloaters({floaters}));
  // fetchingFloaters = false;
  redraw({});

}

export function* addFloaterSaga({prId, callbackAfterAddedFloater}) {

  // fetchingFloaters = true;
  const requestPostOptions = buildRequestJsonPostOptions({id:prId})

  const requestURL = `${host}/family-tree/add_floater?treeSessionId=${treeSessionId}`;

  const floaters = yield call(request, requestURL, requestPostOptions);

  yield put(setFloaters({floaters}));

  if(floaters.length) {

    if(floaters.length === 1){
      callbackAfterAddedFloater()
    }

  } else {

    const serverMessage = 'Something went wrong!';
    console.log(serverMessage);

  }
  // fetchingFloaters = false;

}

export function* postAddExistingSaga({ floater_profile_id, focusPrid, rel, dropOnPrId, marriageId, callNotification }) {

  console.log(`{ floater_profile_id, focusPrid, rel, dropOnPrId, marriageId, callNotification }: `, JSON.stringify({ floater_profile_id, focusPrid, rel, dropOnPrId, marriageId, callNotification }, null, 2));

  const requestPostOptions = buildRequestJsonPostOptions({
                                  id: dropOnPrId,
                                  floater_profile_id,
                                  focus_id: focusPrid,
                                  rel,
                                  union_id: marriageId
                                });

  const requestURL = `${host}/family-tree/add_existing?treeSessionId=${treeSessionId}`;

  try {
    const data = yield call(request, requestURL, requestPostOptions);

    if(data.success) {

      // console.log(JSON.stringify(data, null, 2));

      if(rel === 'same'){

        // console.log(`will redirect to: `, data.location);
        window.document.location = data.location;

      } else {

        const href = data.location;
        const path = href.split('?')[0];
        const pathArray = path.split('/');
        const lastElementOfPathArray = pathArray.slice(-1)[0];
        const focus_pr_id = lastElementOfPathArray.split('#')[0];
        const highlight_pr_id = lastElementOfPathArray.split('#')[1];
        // console.log(`window.callReloadCanvasTree('+ focus_pr_id+', ' + highlight_pr_id + '): `, JSON.stringify({focus_pr_id, highlight_pr_id}, null, 2));
        const param = { prIdToTeleport: highlight_pr_id };
        window.callReloadCanvasTree(focus_pr_id, param);

      }

    } else {

      callNotification({msg: data.error});

    }

  } catch (err) {
    console.log(err);
    callNotification({msg: err});
  }

}

export function* postResolve({focusPrId, parent, sibling, children, partner, closeResolveModal}) {

  closeResolveModal();

  const resolveObj = {
    parent,
    sibling,
    children,
    partner,
  }

  const idObjs = {
    parent: '',
    sibling: '',
    children: '',
    partner: '',
  }

  const buildIdString = (container) => {
    resolveObj[container].forEach((eachArray) => {
      eachArray.forEach((prId, idx) => {
        if(idx === eachArray.length - 1){
          idObjs[container] += `${prId},`;
        } else{
          idObjs[container] += `${prId}%2B`;
        }
      });
    });
  }

  for( const key in resolveObj ){
    if(typeof(key) !== 'undefined') buildIdString(key);
  }

  let idParmStr = '';
  for( const key in resolveObj ){
    idParmStr += `${idObjs[key]}`;
  }

  const redirectURL = `${host}/merge/duplicates?treeSessionId=${treeSessionId}&focus_id=${focusPrId}&ids=${idParmStr}`;
  console.log(`redirectURL: `, redirectURL);
  window.location = redirectURL;
  yield delay(0);
}

function *sagaWatchAll() {
  yield all([
    takeLatest(FETCH_TREE, fetchTreeSaga),
    takeLatest(POST_RESOLVE, postResolve),
    takeLatest(FETCH_IMMEDIATE_FAMILY, fetchImmediateFamilySaga),
    takeLatest(FETCH_LEGEND_DESCRIPTIONS, fetchLegendDescriptions),
    takeLatest(FETCH_FLIPDATA, fetchFlipDataSaga),
    takeLatest(FETCH_PRUNES, spawnFetchPrunes),
    takeLatest(FETCH_PROFILES, spawnFetchProfiles),
    takeLatest(FLUSHALLCALLBACKFORFETCHPROFILES, flushAllCallbackForFetchProfiles),
    takeLatest(RELEASEQUEUEFETCHEDPROFILESDATA, releaseQueueFetchedProfilesSaga),
    takeLatest(CHECKQUEUEFETCHEDNODEOBJPIC, checkQueueFetchedNodeObjPic),
    takeLatest(RELEASEQUEUEOFFETCHEDNODEOBJPICS, releaseQueueOfFetchedNodeObjPics),
    takeLatest(NOTIFYPROFILEADD, notifyProfileAdd),
    takeLatest(UPDATEMATCHCOUNTS, updateMatchCounts),
    takeLatest(UNSET_FLIPDATA, unsetFlipDataSaga),
    takeLatest(UNSET_NODEOBJ_PROP, unsetNodeObjProperties),
    takeLatest(UNSET_NODEOBJ_PIC, unsetNodeObjPic),
    takeLatest(UNSET_NODEOBJ_GEDCOM, unsetNodeObjGedcom),
    takeLatest(SET_NODEOBJ_PIC, setNodeObjPic),
    takeLatest(UNDESIGNATE_DROPTARGET, undesignateDropTarget),
    takeLatest(FETCH_PREFERENCES, fetchPrefencesSaga),
    takeLatest(POST_INVITE, postInvite),
    takeLatest(POST_PREFERENCES, postPreferences),
    takeLatest(POST_POSTER, postPoster),
    takeLatest(GETUNION_ID_FANCHART, getUnionIdForFanChart),
    takeLatest(UPLOADPHOTO, uploadPhoto),
    takeLatest(POSTREDUX_PREFERENCES, postReduxPreferences),
    takeLatest(POST_PREFERENCESCHARTTYPE, postPreferencesChartType),
    takeLatest(POST_CHOSENUNIONID, postChosenUnionId),
    takeLatest(POST_ADD_EXISTING, postAddExistingSaga),
    takeLatest(STOP_INFLIGHT_SAGAS, make_inflight_sagas_stop),
    takeLatest(FETCH_FLOATERS, fetchFloatersSaga),
    takeLatest(ADD_FLOATER, addFloaterSaga),
    takeLatest(REMOVE_FLOATER, removeFloaterSaga),
    takeLatest(CANCEL_SPAWNED_FETCHPROFILES, cancelAllSpawnedFetchProfilesSaga),
  ]);
}

export default sagaWatchAll;


